import { Component, Input, ViewChild, NgModule, ElementRef, HostListener, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output, Injectable, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IconModule } from '@wke/ucc-icons';
import { CommonModule as CommonModule$1, TooltipModule, LocaleService, LocalizationModule } from '@wke/ucc-angular-alt-common';
import { NavigationService } from '@wke/ucc-angular-alt-navigation';
import { trigger, transition, animate, style, keyframes } from '@angular/animations';
import { ContentLoaderComponent, ContentLoaderModule } from '@wke/ucc-angular-alt-content-loaders';
import { FormsModule } from '@angular/forms';
import { InputsModule } from '@wke/ucc-angular-alt-inputs';
import { ProgressButtonModule } from '@wke/ucc-angular-alt-buttons';
import { UccDrawingModule } from '@wke/ucc-angular-drawing';
import { ModalService } from '@wke/ucc-angular-alt-modal';

/**
 * Este componente recibe una serie de [Shuttle Card Items]{@link ShuttleCardItem} a través de una Array, los cuales se instancian
 * dentro de una página con una distribución predeterminada
 *
 * @example
 * <ngwk-shuttle-page [shuttleCards]='shuttleCards'></ngwk-shuttle-page>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@wke/ucc-angular-alt-navigation';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@wke/ucc-icons';
import * as ɵngcc5 from '@wke/ucc-angular-alt-common';
import * as ɵngcc6 from '@wke/ucc-angular-alt-content-loaders';
import * as ɵngcc7 from '@wke/ucc-angular-alt-inputs';
import * as ɵngcc8 from '@angular/forms';
import * as ɵngcc9 from '@wke/ucc-angular-alt-buttons';
import * as ɵngcc10 from '@wke/ucc-angular-drawing';
import * as ɵngcc11 from '@wke/ucc-angular-alt-modal';

const _c0 = function (a0) { return { "breakLine": a0 }; };
function ShuttlePageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "ngwk-shuttle-card-item", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c0, item_r1.breakLine));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r1);
} }
const _c1 = ["primaryType"];
const _c2 = ["linksType"];
const _c3 = ["insightsType"];
const _c4 = ["buttonType"];
const _c5 = ["smallType"];
const _c6 = ["customType"];
const _c7 = ["default"];
function ShuttleCardItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Type: NO-TYPE");
    ɵngcc0.ɵɵelementEnd();
} }
function ShuttleCardItemComponent_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", ctx_r21.completeItem == null ? null : ctx_r21.completeItem.badge.icon)("iconColor", ctx_r21.completeItem == null ? null : ctx_r21.completeItem.badge.color)("iconSize", ctx_r21.completeItem == null ? null : ctx_r21.completeItem.badge.size)("ngwkTooltip", ctx_r21.completeItem == null ? null : ctx_r21.completeItem.badge.tooltip);
} }
function ShuttleCardItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function ShuttleCardItemComponent_ng_template_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onPanelClick(ctx_r22.completeItem); });
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, ShuttleCardItemComponent_ng_template_2_div_3_Template, 2, 4, "div", 14);
    ɵngcc0.ɵɵelementStart(4, "div", 15);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r3.completeItem.id)("ngClass", ctx_r3.getClass(ctx_r3.completeItem));
    ɵngcc0.ɵɵattribute("disabled", ctx_r3.isDisabled());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("key", ctx_r3.completeItem == null ? null : ctx_r3.completeItem.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.completeItem == null ? null : ctx_r3.completeItem.badge);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.completeItem == null ? null : ctx_r3.completeItem.label);
} }
function ShuttleCardItemComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function ShuttleCardItemComponent_ng_template_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onPanelClick(ctx_r24.completeItem); });
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 15);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r5.completeItem.id);
    ɵngcc0.ɵɵattribute("disabled", ctx_r5.isDisabled());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("key", ctx_r5.completeItem == null ? null : ctx_r5.completeItem.icon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.completeItem == null ? null : ctx_r5.completeItem.label);
} }
function ShuttleCardItemComponent_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵlistener("click", function ShuttleCardItemComponent_ng_template_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.onPanelClick(ctx_r27.completeItem); });
    ɵngcc0.ɵɵtemplate(1, ShuttleCardItemComponent_ng_template_6_ng_container_1_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r7.completeItem.id)("ngClass", ctx_r7.getClass(ctx_r7.completeItem));
    ɵngcc0.ɵɵattribute("disabled", ctx_r7.isDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.itemCustom == null ? null : ctx_r7.itemCustom.customTemplate)("ngTemplateOutletContext", ctx_r7.customContext);
} }
function ShuttleCardItemComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ShuttleCardItemComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 21);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function ShuttleCardItemComponent_ng_template_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵlistener("click", function ShuttleCardItemComponent_ng_template_10_div_3_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r34); const link_r32 = restoredCtx.$implicit; const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.onClickLink(link_r32); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 26);
    ɵngcc0.ɵɵelement(4, "ucc-icon", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r32 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("id", link_r32.idLink);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(link_r32 == null ? null : link_r32.label);
} }
function ShuttleCardItemComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, ShuttleCardItemComponent_ng_template_10_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 23);
    ɵngcc0.ɵɵtemplate(3, ShuttleCardItemComponent_ng_template_10_div_3_Template, 5, 2, "div", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵattribute("disabled", ctx_r11.isDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.itemLink == null ? null : ctx_r11.itemLink.links);
} }
function ShuttleCardItemComponent_ng_template_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_12_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵtemplate(1, ShuttleCardItemComponent_ng_template_12_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 29);
    ɵngcc0.ɵɵelementStart(3, "div", 30);
    ɵngcc0.ɵɵtemplate(4, ShuttleCardItemComponent_ng_template_12_ng_container_4_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵattribute("disabled", ctx_r13.isDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.itemInsights == null ? null : ctx_r13.itemInsights.templateRef)("ngTemplateOutletContext", ctx_r13.context);
} }
function ShuttleCardItemComponent_ng_template_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtemplate(1, ShuttleCardItemComponent_ng_template_14_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementStart(2, "button", 32);
    ɵngcc0.ɵɵlistener("click", function ShuttleCardItemComponent_ng_template_14_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.onClickButton(ctx_r38.completeItem); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", (ctx_r15.itemButton == null ? null : ctx_r15.itemButton.buttonId) ? ctx_r15.itemButton == null ? null : ctx_r15.itemButton.buttonId : ctx_r15.itemButton == null ? null : ctx_r15.itemButton.buttonLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.itemButton == null ? null : ctx_r15.itemButton.buttonLabel);
} }
function ShuttleCardItemComponent_ng_template_16_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ShuttleCardItemComponent_ng_template_16_ng_container_0_Template, 1, 0, "ng-container", 21);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function ShuttleCardItemComponent_ng_template_18_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ShuttleCardItemComponent_ng_template_18_ng_container_0_Template, 1, 0, "ng-container", 21);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function ShuttleCardItemComponent_ng_container_20_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ShuttleCardItemComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ShuttleCardItemComponent_ng_container_20_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r20.getTemplateRef(ctx_r20.completeItem));
} }
function ListPageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("@filterAnimation", undefined);
} }
function ListPageComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("@previewAnimation", undefined);
} }
function ListPageComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "list-page-content-loader", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@fadeOut", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("columns", ctx_r2.contentLoaderColumns)("contentLoaderContainer", ctx_r2.contentLoaderContainer);
} }
const _c8 = [[["list-header"]], [["list-datagrid"]], [["list-filter"]], [["list-preview"]]];
const _c9 = ["list-header", "list-datagrid", "list-filter", "list-preview"];
const _c10 = function (a0, a1) { return { "margin-right.px": a0, "padding-right.px": a1 }; };
function ListPageContentLoaderComponent_line_content_loader_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "line-content-loader", 9);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(4, _c10, ctx_r0.headerColumnMargin, ctx_r0.headerColumnPadding))("lineWidth", ctx_r0.headerColumnWidth)("lineHeight", 9)("lines", 1);
} }
const _c11 = function (a0) { return { "margin-right.px": a0 }; };
function ListPageContentLoaderComponent_div_11_line_content_loader_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "line-content-loader", 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c11, ctx_r4.columnMargin))("lineWidth", ctx_r4.columnWidth)("lineHeight", 7.5)("lines", 1);
} }
function ListPageContentLoaderComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, ListPageContentLoaderComponent_div_11_line_content_loader_2_Template, 1, 6, "line-content-loader", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.totalColumns);
} }
const _c12 = [[["detail-anchor"]], [["detail-content"]], [["detail-actionbar"]]];
const _c13 = ["detail-anchor", "detail-content", "detail-actionbar"];
function DocumentPageComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DocumentPageComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onFloatingButtonClick(); });
    ɵngcc0.ɵɵelement(1, "ucc-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.colorClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", ctx_r0.floatingButtonIcon);
} }
const _c14 = [[["document-header"]], [["document-content"]], [["document-footer"]]];
const _c15 = ["document-header", "document-content", "document-footer"];
const _c16 = ["*"];
const _c17 = [[["actionbar-left"]], [["actionbar-right"]]];
const _c18 = ["actionbar-left", "actionbar-right"];
function EmptyStateComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "button", 8);
    ɵngcc0.ɵɵlistener("click", function EmptyStateComponent_div_9_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onButtonClick(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.buttonContent);
} }
function ListHeaderComponent_ngwk_search_box_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-search-box", 4);
    ɵngcc0.ɵɵlistener("search", function ListHeaderComponent_ngwk_search_box_5_Template_ngwk_search_box_search_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onSearch($event); })("clear", function ListHeaderComponent_ngwk_search_box_5_Template_ngwk_search_box_clear_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onClear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("placeholder", ctx_r0.placeholderSearch);
} }
const _c19 = [[["list-header-content"]]];
const _c20 = ["list-header-content"];
const _c21 = ["btnLogin"];
const _c22 = ["emailTextbox"];
function LoginComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelement(1, "ucc-alert-card", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("message", error_r5);
} }
function LoginComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, LoginComponent_div_5_div_1_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.errors);
} }
const _c23 = function (a0, a1) { return { "wizardIndexSelected": a0, "wizardIndexDisabled": a1 }; };
const _c24 = function (a0, a1) { return { "ovalListItemDisabled": a0, "ovalListItemChecked": a1 }; };
const _c25 = function (a0) { return { "wizardIndexDisabled": a0 }; };
function WizardModalComponent_span_6_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelement(2, "div", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 20);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c23, ctx_r8.setIndexSelected(step_r7), ctx_r8.setIndexDisabled(step_r7)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c24, ctx_r8.setDisabledColor(step_r7), ctx_r8.setCheckedOvalColor(step_r7)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c25, ctx_r8.setDisabledColor(step_r7)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r7.indexTitle, " ");
} }
function WizardModalComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, WizardModalComponent_span_6_li_1_Template, 5, 12, "li", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r7 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isStepShowed(step_r7));
} }
function WizardModalComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "ucc-icon", 24);
    ɵngcc0.ɵɵlistener("click", function WizardModalComponent_div_16_Template_ucc_icon_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onCloseIcon(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("disabled", ctx_r1.isCloseIconDisabled());
} }
function WizardModalComponent_ng_container_18_div_1_1_ng_template_0_Template(rf, ctx) { }
function WizardModalComponent_ng_container_18_div_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, WizardModalComponent_ng_container_18_div_1_1_ng_template_0_Template, 0, 0, "ng-template");
} }
function WizardModalComponent_ng_container_18_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtemplate(1, WizardModalComponent_ng_container_18_div_1_1_Template, 1, 0, undefined, 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", step_r12.template);
} }
function WizardModalComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, WizardModalComponent_ng_container_18_div_1_Template, 2, 1, "div", 25);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const step_r12 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.currentStep.id === step_r12.id);
} }
function WizardModalComponent_button_22_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function WizardModalComponent_button_22_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onDiscard(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.discardDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.resources.discardButton);
} }
function WizardModalComponent_button_25_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function WizardModalComponent_button_25_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onPrev(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.prevDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.resources.prevButton);
} }
function WizardModalComponent_button_26_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function WizardModalComponent_button_26_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onNext(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r5.nextDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.resources.nextButton);
} }
function WizardModalComponent_button_27_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function WizardModalComponent_button_27_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onClose(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r6.closeDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.resources.closeButton);
} }
function AnchorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AnchorComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c26 = [[["anchor-expanded"]], [["anchor-collapsed"]]];
const _c27 = ["anchor-expanded", "anchor-collapsed"];
class ShuttlePageComponent {
    /** @ignore */
    constructor() {
        this._shuttleCards = [];
    }
    /**
     * Permite obtener la lista de Shuttle Card Items que posee esta página
     */
    get shuttleCards() {
        return this._shuttleCards;
    }
    /**
     * Permite definir la lista de Shuttle Card Items que se instanciaran en la página
     *
     * @param value La lista de Shuttle Card Items
     */
    set shuttleCards(value) {
        this._shuttleCards = value;
    }
}
ShuttlePageComponent.ɵfac = function ShuttlePageComponent_Factory(t) { return new (t || ShuttlePageComponent)(); };
ShuttlePageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShuttlePageComponent, selectors: [["ngwk-shuttle-page"]], inputs: { shuttleCards: "shuttleCards" }, decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "item"]], template: function ShuttlePageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ShuttlePageComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.shuttleCards);
    } }, directives: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgClass, ShuttleCardItemComponent]; }, styles: ["[_nghost-%COMP%]{background:#f5f5f5;padding:16px;height:100%;width:auto;position:relative;flex:1 1;overflow-y:auto}[_nghost-%COMP%]   .breakLine[_ngcontent-%COMP%]{width:100%;height:165px}"] });
/** @nocollapse */
ShuttlePageComponent.ctorParameters = () => [];
ShuttlePageComponent.propDecorators = {
    shuttleCards: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShuttlePageComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-shuttle-page',
                template: "<div *ngFor='let item of shuttleCards' [ngClass]=\"{'breakLine': item.breakLine}\">\r\n    <ngwk-shuttle-card-item [item]='item'></ngwk-shuttle-card-item>\r\n</div>\r\n",
                styles: [":host{background:#f5f5f5;padding:16px;height:100%;width:auto;position:relative;flex:1 1;overflow-y:auto}:host .breakLine{width:100%;height:165px}\n"]
            }]
    }], function () { return []; }, { shuttleCards: [{
            type: Input
        }] }); })();

/**
 * Interfaz del objeto Link, el cual puede realizar la acción de un enlace o de una función
 */
var StyleType;
(function (StyleType) {
    /**
     * Estilo para los paneles primarios
     */
    StyleType[StyleType["primary"] = 1] = "primary";
    /**
     * Estilo para los paneles secundarios
     */
    StyleType[StyleType["secondary"] = 2] = "secondary";
})(StyleType || (StyleType = {}));
/**
 * Interfaz que define los diferentes tipos de Shuttle Card Item que hay
 */
var ShuttleCardType;
(function (ShuttleCardType) {
    /** Tipo primary, el cual consiste en un panel con una acción básica, que puede ser un enlace o función */
    ShuttleCardType[ShuttleCardType["primary"] = 1] = "primary";
    /**
     * Tipo links, el cual consiste en dos paneles; uno siendo de tipo Primary, y el otro con una lista de links que
     * pueden ser enlaces o funciones definidas por el usuario
     */
    ShuttleCardType[ShuttleCardType["links"] = 2] = "links";
    /** Tipo insights, el cual consiste en dos paneles; uno siendo de tipo Primary, y el otro en un panel con template y
     *  contexto definidos por el usuario
     */
    ShuttleCardType[ShuttleCardType["insights"] = 3] = "insights";
    /** Tipo primary, el cual consiste en un panel con una acción básica, que puede ser un enlace o función, y un botón,
     *  el cual también puede realizar la acción de enlace o función
     */
    ShuttleCardType[ShuttleCardType["button"] = 4] = "button";
    /** Tipo small, el cual es similar al tipo primary pero con un tamaño del Shuttle Card más reducido */
    ShuttleCardType[ShuttleCardType["small"] = 5] = "small";
    /**
     * Tipo custom, el cual consiste en un panel al cual se le pasa una template custom. Consta de una acción básica,
     * que puede ser un enlace o función
     */
    ShuttleCardType[ShuttleCardType["customTemplate"] = 6] = "customTemplate";
})(ShuttleCardType || (ShuttleCardType = {}));

/**
 * Este componente instancia un [Shuttle Card Item]{@link ShuttleCardItem}, el cual se pasa a través del Input 'item'
 *
 * @example
 * <ngwk-shuttle-card-item [item]='item'></ngwk-shuttle-card-item>
 */
class ShuttleCardItemComponent {
    /**@ignore */
    constructor(_navigationService, _activatedRoute) {
        this._navigationService = _navigationService;
        this._activatedRoute = _activatedRoute;
        this._item = null;
        this.completeItem = null;
    }
    //#region Public Methods
    /** @ignore */
    getTemplateRef(item) {
        switch (item.type) {
            case ShuttleCardType.primary:
                return this.primaryTypeTemplate;
            case ShuttleCardType.links:
                return this.linksTypeTemplate;
            case ShuttleCardType.insights:
                return this.insightsTypeTemplate;
            case ShuttleCardType.button:
                return this.buttonTypeTemplate;
            case ShuttleCardType.small:
                return this.smallTypeTemplate;
            case ShuttleCardType.customTemplate:
                return this.customTypeTemplate;
            default:
                return this.defaultTemplate;
        }
    }
    /** @ignore */
    getClass(item) {
        switch (item.styleType) {
            case StyleType.primary:
                return 'primaryTile';
            case StyleType.secondary:
                return 'secondaryTile';
            default:
                return 'primaryTile';
        }
    }
    /** @ignore */
    isDisabled() {
        return this.completeItem.onLink === undefined ? true : null;
    }
    /** @ignore */
    onPanelClick(item) {
        this.onClick(item.onLink);
    }
    /** @ignore */
    onClickLink(item) {
        this.onClick(item.onLink);
    }
    /** @ignore */
    onClickButton(item) {
        this.onClick(item.buttonOnLink);
    }
    onClick(link) {
        this._navigationService.go(link, { relativeTo: this._activatedRoute });
    }
    //#endregion
    /**
     * Permite obtener el item del componente, el cual es de tipo [Shuttle Card Item]{@link ShuttleCardItem}
     */
    get item() {
        return this._item;
    }
    /**
     * Permite definir el item del componente, el cual es de tipo [Shuttle Card Item]{@link ShuttleCardItem}
     *
     * @param value El item del componente
     */
    set item(value) {
        this._item = value;
        this.completeItem = this._item;
        if (!this._item.icon) {
            this.completeItem = Object.assign(Object.assign({}, DEFAULT_ICON_ITEM), this._item);
        }
        if (this._item.badge) {
            const completeBadgeItem = Object.assign(Object.assign({}, DEFAULT_BADGE_SHUTTLE_ITEM), this._item.badge);
            this.completeItem.badge = completeBadgeItem;
        }
    }
    /** @ignore */
    get itemButton() {
        return this.completeItem.type === ShuttleCardType.button ? this.completeItem : null;
    }
    /** @ignore */
    get itemLink() {
        return this.completeItem.type === ShuttleCardType.links ? this.completeItem : null;
    }
    /** @ignore */
    get itemInsights() {
        return this.completeItem.type === ShuttleCardType.insights ? this.completeItem : null;
    }
    /** @ignore */
    get itemCustom() {
        return this.completeItem.type === ShuttleCardType.customTemplate ? this.completeItem : null;
    }
    /** @ignore */
    get context() {
        let linkItem = this.completeItem;
        return {
            $implicit: linkItem.templateContext,
            context: linkItem.templateContext
        };
    }
    /** @ignore */
    get customContext() {
        let linkItem = this.completeItem;
        return {
            $implicit: linkItem.customTemplateContext,
            context: linkItem.customTemplateContext
        };
    }
}
ShuttleCardItemComponent.ɵfac = function ShuttleCardItemComponent_Factory(t) { return new (t || ShuttleCardItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NavigationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute)); };
ShuttleCardItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShuttleCardItemComponent, selectors: [["ngwk-shuttle-card-item"]], viewQuery: function ShuttleCardItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(_c2, 7);
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(_c4, 7);
        ɵngcc0.ɵɵviewQuery(_c5, 7);
        ɵngcc0.ɵɵviewQuery(_c6, 7);
        ɵngcc0.ɵɵviewQuery(_c7, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.primaryTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.linksTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.insightsTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.smallTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customTypeTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
    } }, inputs: { item: "item" }, decls: 21, vars: 1, consts: [["default", ""], ["baseType", ""], ["smallBaseType", ""], ["customBaseType", ""], ["primaryType", ""], ["linksType", ""], ["insightsType", ""], ["buttonType", ""], ["smallType", ""], ["customType", ""], [4, "ngIf"], [1, "baseTypeContainer", 3, "id", "ngClass", "click"], [1, "rowAuto", "primaryTileIcon"], [1, "rowAuto", 3, "key"], ["class", "badgeContainer", 4, "ngIf"], [1, "rowAuto"], [1, "badgeContainer"], [3, "key", "iconColor", "iconSize", "ngwkTooltip"], [1, "smallTile", 3, "id", "click"], [1, "alignVerticalMiddle", 3, "id", "ngClass", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"], [1, "horizontalLayout", "colAuto", "linksType"], [1, "secondaryZoneLinkTile"], ["class", "rowAvailable secondaryZoneLink alignVerticalMiddle", 3, "id", "click", 4, "ngFor", "ngForOf"], [1, "rowAvailable", "secondaryZoneLink", "alignVerticalMiddle", 3, "id", "click"], [1, "colAvailable"], ["key", "angle-right", 1, "colAuto"], [1, "horizontalLayout", "colAuto", "insightsType"], [1, "secondaryZoneInsightsTile", "alignVerticalMiddle"], [1, "rowAvailable"], [1, "verticalLayout", "rowAuto", "buttonTile"], [1, "buttonFooterTile", 3, "id", "click"]], template: function ShuttleCardItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ShuttleCardItemComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, ShuttleCardItemComponent_ng_template_2_Template, 7, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, ShuttleCardItemComponent_ng_template_4_Template, 6, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, ShuttleCardItemComponent_ng_template_6_Template, 2, 5, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, ShuttleCardItemComponent_ng_template_8_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, ShuttleCardItemComponent_ng_template_10_Template, 4, 3, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, ShuttleCardItemComponent_ng_template_12_Template, 5, 4, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, ShuttleCardItemComponent_ng_template_14_Template, 4, 3, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(16, ShuttleCardItemComponent_ng_template_16_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(18, ShuttleCardItemComponent_ng_template_18_Template, 1, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(20, ShuttleCardItemComponent_ng_container_20_Template, 2, 1, "ng-container", 10);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("ngIf", ctx.completeItem != null);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc4.IconComponent, ɵngcc5.NgwkTooltipDirective, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]    {float:left;margin-right:15px;margin-bottom:15px}[_nghost-%COMP%]     .baseTypeContainer{position:relative}[_nghost-%COMP%]     .primaryTile{background:linear-gradient(#429ed6,#2481c6);color:#fff;font-size:16px;height:150px;width:150px;text-align:center;font-family:\"FiraSans Regular\";font-family:\"Fira Sans\",arial,sans-serif;cursor:pointer;padding:0 10px;box-shadow:4px 4px 10px #00000026}[_nghost-%COMP%]     .primaryTile:hover{opacity:.8;box-shadow:none}[_nghost-%COMP%]     .primaryTile[disabled]{cursor:default!important;pointer-events:none}[_nghost-%COMP%]     .primaryTileIcon{display:flex;justify-content:center;flex-direction:column;margin-bottom:8px;padding-top:30px}[_nghost-%COMP%]     .primaryTileIcon i{font-size:40px}[_nghost-%COMP%]     .badgeContainer{position:absolute;top:10px;right:10px}[_nghost-%COMP%]     .secondaryTile{display:block;font-size:16px;height:150px;width:150px;color:#757575;background-color:#fff;text-align:center;font-family:\"FiraSans Regular\";font-family:\"Fira Sans\",arial,sans-serif;cursor:pointer;padding:0 10px;box-shadow:4px 4px 10px #00000014}[_nghost-%COMP%]     .secondaryTile:hover{opacity:.8}[_nghost-%COMP%]     .secondaryTile[disabled]{cursor:default!important;pointer-events:none}[_nghost-%COMP%]     .secondaryTile[disabled] .baseIcon{color:#acacac}[_nghost-%COMP%]     .secondaryTile .baseIcon{color:#0081c6}[_nghost-%COMP%]     .linksType{box-shadow:4px 4px 10px #00000014}[_nghost-%COMP%]     .linksType .primaryTile{box-shadow:none}[_nghost-%COMP%]     .linksType .secondaryTile{box-shadow:none}[_nghost-%COMP%]     .linksType .secondaryZoneLinkTile{box-shadow:none}[_nghost-%COMP%]     .linksType .secondaryZoneInsightsTile{box-shadow:none}[_nghost-%COMP%]     .secondaryZoneLinkTile{background:#fff;color:#007ac3;display:flex;flex-direction:column;width:165px;font-size:12px;margin:0;padding-left:0;box-shadow:4px 4px 10px #00000026;cursor:pointer}[_nghost-%COMP%]     .secondaryZoneLinkTile .secondaryZoneLink{padding:0 15px;background:linear-gradient(90deg,transparent,transparent),linear-gradient(90deg,transparent,#ccc);background-size:100% 1px;background-position:0 0,0 100%;background-repeat:no-repeat}[_nghost-%COMP%]     .secondaryZoneLinkTile .secondaryZoneLink:hover{background-color:#f8f8f8;cursor:pointer}[_nghost-%COMP%]     .secondaryZoneLinkTile .secondaryZoneLink:last-child{border:none}[_nghost-%COMP%]     .secondaryZoneLinkTile .baseIcon{font-size:11px;color:#888}[_nghost-%COMP%]     .secondaryZoneInsightsTile{display:flex;font-size:13px;height:150px;width:165px;color:#000;background-color:#fff;cursor:pointer;box-shadow:5px 10px #888;box-shadow:4px 4px 10px #00000026}[_nghost-%COMP%]     .insightsType{box-shadow:4px 4px 10px #00000014}[_nghost-%COMP%]     .insightsType .primaryTile{box-shadow:none}[_nghost-%COMP%]     .insightsType .secondaryTile{box-shadow:none}[_nghost-%COMP%]     .insightsType .secondaryZoneLinkTile{box-shadow:none}[_nghost-%COMP%]     .insightsType .secondaryZoneInsightsTile{box-shadow:none}[_nghost-%COMP%]     .smallTile{display:block;font-size:10px;height:75px;width:75px;background-color:#fff;text-align:center;cursor:pointer;padding:0 6px;box-shadow:4px 4px 10px #00000014}[_nghost-%COMP%]     .smallTile:hover{opacity:.8}[_nghost-%COMP%]     .smallTile .primaryTileIcon{margin-left:auto;margin-right:auto;height:30px;color:#0081c6;margin-bottom:11px}[_nghost-%COMP%]     .smallTile i{font-size:30px;padding-bottom:10px}[_nghost-%COMP%]     .tileIconPosition{margin-left:auto;margin-right:auto;height:75px;font-size:30px}[_nghost-%COMP%]     .buttonTile{box-shadow:4px 4px 10px #00000014}[_nghost-%COMP%]     .buttonTile .primaryTile{height:115px;box-shadow:none}[_nghost-%COMP%]     .buttonFooterTile{width:150px;height:35px;color:#fff;background-color:#429ed6;border:none;border-top:1px solid #bcd7e7;cursor:pointer}[_nghost-%COMP%]     .buttonFooterTile:hover{opacity:.8}"] });
/** @nocollapse */
ShuttleCardItemComponent.ctorParameters = () => [
    { type: NavigationService },
    { type: ActivatedRoute }
];
ShuttleCardItemComponent.propDecorators = {
    primaryTypeTemplate: [{ type: ViewChild, args: ['primaryType', { static: true },] }],
    linksTypeTemplate: [{ type: ViewChild, args: ['linksType', { static: true },] }],
    insightsTypeTemplate: [{ type: ViewChild, args: ['insightsType', { static: true },] }],
    buttonTypeTemplate: [{ type: ViewChild, args: ['buttonType', { static: true },] }],
    smallTypeTemplate: [{ type: ViewChild, args: ['smallType', { static: true },] }],
    customTypeTemplate: [{ type: ViewChild, args: ['customType', { static: true },] }],
    defaultTemplate: [{ type: ViewChild, args: ['default', { static: true },] }],
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShuttleCardItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-shuttle-card-item',
                template: "<ng-template #default>\r\n    <div>Type: NO-TYPE</div>\r\n</ng-template>\r\n\r\n<ng-template #baseType>\r\n    <div class=\"baseTypeContainer\" [id]=\"completeItem.id\" [ngClass]='getClass(completeItem)' (click)='onPanelClick(completeItem)' [attr.disabled]=\"isDisabled()\">\r\n        <div class=\"rowAuto primaryTileIcon\">\r\n            <ucc-icon [key]='completeItem?.icon' class='rowAuto'></ucc-icon>\r\n        </div>\r\n        <div *ngIf=\"completeItem?.badge\" class=\"badgeContainer\">\r\n            <ucc-icon [key]='completeItem?.badge.icon' [iconColor]=\"completeItem?.badge.color\" [iconSize]=\"completeItem?.badge.size\" [ngwkTooltip]=\"completeItem?.badge.tooltip\"></ucc-icon>\r\n        </div>\r\n        <div class=\"rowAuto\">\r\n            <span>{{completeItem?.label}}</span>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #smallBaseType>\r\n    <div [id]=\"completeItem.id\" class='smallTile' (click)='onPanelClick(completeItem)' [attr.disabled]=\"isDisabled()\">\r\n        <div class=\"rowAuto primaryTileIcon\">\r\n            <ucc-icon [key]='completeItem?.icon' class='rowAuto'></ucc-icon>\r\n        </div>\r\n        <div class=\"rowAuto\">\r\n            <span>{{completeItem?.label}}</span>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #customBaseType>\r\n    <div [id]=\"completeItem.id\" class=\"alignVerticalMiddle\" [ngClass]='getClass(completeItem)' (click)='onPanelClick(completeItem)' [attr.disabled]=\"isDisabled()\">\r\n        <ng-container *ngTemplateOutlet=\"itemCustom?.customTemplate; context: customContext\"></ng-container>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #primaryType>\r\n    <ng-container *ngTemplateOutlet='baseType'></ng-container>\r\n</ng-template>\r\n\r\n<ng-template #linksType>\r\n    <div class='horizontalLayout colAuto linksType' [attr.disabled]=\"isDisabled()\">\r\n        <ng-container *ngTemplateOutlet='baseType'></ng-container>\r\n        <div class=\"secondaryZoneLinkTile\">\r\n            <div *ngFor='let link of itemLink?.links' [id]=\"link.idLink\" class='rowAvailable secondaryZoneLink alignVerticalMiddle' (click)='onClickLink(link)'>\r\n                <span>{{link?.label}}</span>\r\n                <div class=\"colAvailable\"></div>\r\n                <ucc-icon class='colAuto' key='angle-right'></ucc-icon>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #insightsType>\r\n    <div class='horizontalLayout colAuto insightsType' [attr.disabled]=\"isDisabled()\">\r\n        <ng-container *ngTemplateOutlet='baseType'></ng-container>\r\n        <div class=\"secondaryZoneInsightsTile alignVerticalMiddle\">\r\n            <div class='rowAvailable'>\r\n                <ng-container *ngTemplateOutlet=\"itemInsights?.templateRef; context: context\"></ng-container>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #buttonType>\r\n    <div class='verticalLayout rowAuto buttonTile'>\r\n        <ng-container *ngTemplateOutlet='baseType'></ng-container>\r\n        <button id=\"{{itemButton?.buttonId ? itemButton?.buttonId : itemButton?.buttonLabel}}\" class='buttonFooterTile' (click)='onClickButton(completeItem)'>{{itemButton?.buttonLabel}}</button>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #smallType>\r\n    <ng-container *ngTemplateOutlet='smallBaseType'></ng-container>\r\n</ng-template>\r\n\r\n<ng-template #customType>\r\n    <ng-container *ngTemplateOutlet='customBaseType'></ng-container>\r\n</ng-template>\r\n\r\n<ng-container *ngIf='this.completeItem != null'>\r\n    <ng-container *ngTemplateOutlet='getTemplateRef(completeItem)'></ng-container>\r\n</ng-container>\r\n",
                styles: [":host ::ng-deep{float:left;margin-right:15px;margin-bottom:15px}:host ::ng-deep .baseTypeContainer{position:relative}:host ::ng-deep .primaryTile{background:linear-gradient(#429ed6,#2481c6);color:#fff;font-size:16px;height:150px;width:150px;text-align:center;font-family:\"FiraSans Regular\";font-family:\"Fira Sans\",arial,sans-serif;cursor:pointer;padding:0 10px;box-shadow:4px 4px 10px #00000026}:host ::ng-deep .primaryTile:hover{opacity:.8;box-shadow:none}:host ::ng-deep .primaryTile[disabled]{cursor:default!important;pointer-events:none}:host ::ng-deep .primaryTileIcon{display:flex;justify-content:center;flex-direction:column;margin-bottom:8px;padding-top:30px}:host ::ng-deep .primaryTileIcon i{font-size:40px}:host ::ng-deep .badgeContainer{position:absolute;top:10px;right:10px}:host ::ng-deep .secondaryTile{display:block;font-size:16px;height:150px;width:150px;color:#757575;background-color:#fff;text-align:center;font-family:\"FiraSans Regular\";font-family:\"Fira Sans\",arial,sans-serif;cursor:pointer;padding:0 10px;box-shadow:4px 4px 10px #00000014}:host ::ng-deep .secondaryTile:hover{opacity:.8}:host ::ng-deep .secondaryTile[disabled]{cursor:default!important;pointer-events:none}:host ::ng-deep .secondaryTile[disabled] .baseIcon{color:#acacac}:host ::ng-deep .secondaryTile .baseIcon{color:#0081c6}:host ::ng-deep .linksType{box-shadow:4px 4px 10px #00000014}:host ::ng-deep .linksType .primaryTile{box-shadow:none}:host ::ng-deep .linksType .secondaryTile{box-shadow:none}:host ::ng-deep .linksType .secondaryZoneLinkTile{box-shadow:none}:host ::ng-deep .linksType .secondaryZoneInsightsTile{box-shadow:none}:host ::ng-deep .secondaryZoneLinkTile{background:#fff;color:#007ac3;display:flex;flex-direction:column;width:165px;font-size:12px;margin:0;padding-left:0;box-shadow:4px 4px 10px #00000026;cursor:pointer}:host ::ng-deep .secondaryZoneLinkTile .secondaryZoneLink{padding:0 15px;background:linear-gradient(90deg,transparent,transparent),linear-gradient(90deg,transparent,#ccc);background-size:100% 1px;background-position:0 0,0 100%;background-repeat:no-repeat}:host ::ng-deep .secondaryZoneLinkTile .secondaryZoneLink:hover{background-color:#f8f8f8;cursor:pointer}:host ::ng-deep .secondaryZoneLinkTile .secondaryZoneLink:last-child{border:none}:host ::ng-deep .secondaryZoneLinkTile .baseIcon{font-size:11px;color:#888}:host ::ng-deep .secondaryZoneInsightsTile{display:flex;font-size:13px;height:150px;width:165px;color:#000;background-color:#fff;cursor:pointer;box-shadow:5px 10px #888;box-shadow:4px 4px 10px #00000026}:host ::ng-deep .insightsType{box-shadow:4px 4px 10px #00000014}:host ::ng-deep .insightsType .primaryTile{box-shadow:none}:host ::ng-deep .insightsType .secondaryTile{box-shadow:none}:host ::ng-deep .insightsType .secondaryZoneLinkTile{box-shadow:none}:host ::ng-deep .insightsType .secondaryZoneInsightsTile{box-shadow:none}:host ::ng-deep .smallTile{display:block;font-size:10px;height:75px;width:75px;background-color:#fff;text-align:center;cursor:pointer;padding:0 6px;box-shadow:4px 4px 10px #00000014}:host ::ng-deep .smallTile:hover{opacity:.8}:host ::ng-deep .smallTile .primaryTileIcon{margin-left:auto;margin-right:auto;height:30px;color:#0081c6;margin-bottom:11px}:host ::ng-deep .smallTile i{font-size:30px;padding-bottom:10px}:host ::ng-deep .tileIconPosition{margin-left:auto;margin-right:auto;height:75px;font-size:30px}:host ::ng-deep .buttonTile{box-shadow:4px 4px 10px #00000014}:host ::ng-deep .buttonTile .primaryTile{height:115px;box-shadow:none}:host ::ng-deep .buttonFooterTile{width:150px;height:35px;color:#fff;background-color:#429ed6;border:none;border-top:1px solid #bcd7e7;cursor:pointer}:host ::ng-deep .buttonFooterTile:hover{opacity:.8}\n"]
            }]
    }], function () { return [{ type: ɵngcc2.NavigationService }, { type: ɵngcc3.ActivatedRoute }]; }, { item: [{
            type: Input
        }], primaryTypeTemplate: [{
            type: ViewChild,
            args: ['primaryType', { static: true }]
        }], linksTypeTemplate: [{
            type: ViewChild,
            args: ['linksType', { static: true }]
        }], insightsTypeTemplate: [{
            type: ViewChild,
            args: ['insightsType', { static: true }]
        }], buttonTypeTemplate: [{
            type: ViewChild,
            args: ['buttonType', { static: true }]
        }], smallTypeTemplate: [{
            type: ViewChild,
            args: ['smallType', { static: true }]
        }], customTypeTemplate: [{
            type: ViewChild,
            args: ['customType', { static: true }]
        }], defaultTemplate: [{
            type: ViewChild,
            args: ['default', { static: true }]
        }] }); })();
const DEFAULT_ICON_ITEM = {
    id: 'defaultShuttleCardItemId',
    icon: 'cloud'
};
const DEFAULT_BADGE_SHUTTLE_ITEM = {
    icon: 'circle',
    color: '#ffd02c'
};

class ShuttlePageModule {
}
ShuttlePageModule.ɵfac = function ShuttlePageModule_Factory(t) { return new (t || ShuttlePageModule)(); };
ShuttlePageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ShuttlePageModule });
ShuttlePageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            IconModule,
            CommonModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShuttlePageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    IconModule,
                    CommonModule$1
                ],
                declarations: [
                    ShuttlePageComponent,
                    ShuttleCardItemComponent
                ],
                exports: [
                    ShuttlePageComponent,
                    ShuttleCardItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ShuttlePageModule, { declarations: function () { return [ShuttlePageComponent, ShuttleCardItemComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        IconModule,
        CommonModule$1]; }, exports: function () { return [ShuttlePageComponent, ShuttleCardItemComponent]; } }); })();

/**
 * Este componente sirve para declarar un contenido de una página de tipo lista separado por diferentes zonas,
 * entre las cuales se encuentran las zonas de Header, Filter, Datagrid y Preview
 *
 * @example
 * <ngwk-list-page [isLoading]="isLoading" [contentLoaderColumns]="contentLoaderColumns" [contentLoaderColumnMargin]="contentLoaderColumnMargin">
 *      <list-header>
 *          Header
 *      </list-header>
 *      <list-filter>
 *          Filter
 *      </list-filter>
 *      <list-datagrid>
 *          Datagrid
 *      </list-datagrid>
 *      <list-preview>
 *          Preview
 *      </list-preview>
 * </ngwk-list-page>
 */
class ListPageComponent {
    /**@ignore */
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._isLoading = true;
        this._contentLoaderColumns = 5;
        this._contentLoaderContainer = null;
        this._showFilters = false;
        this._showPreview = false;
    }
    /**
     * Permite consultar el estado de cargando de la List Page. Si la List Page está cargando, aparecerá un content loader de tipo
     * List Page en lugar de la List Page original hasta que los datos estén disponibles
     */
    get isLoading() {
        return this._isLoading;
    }
    /**
     * Permite activar o desactivar el estado de cargando de la List Page. Si la List Page está cargando, aparecerá un content loader
     * de tipo List Page en lugar de la List Page original hasta que los datos estén disponibles
     *
     * @param value Valor que activa o desactiva el estado de cargando de la List Page
     */
    set isLoading(value) {
        this._isLoading = value;
    }
    /**
     * Permite consultar el estado de visibilidad de los filtros en el ListPage
     */
    get showFilters() {
        return this._showFilters;
    }
    /**
     * Permite activar o desactivar la visibilidad de los filtros en el ListPage
     *
     * @param value Valor que activa o desactiva la visibilidad de los filtros en el ListPage
     */
    set showFilters(value) {
        this._showFilters = value;
    }
    /**
     * Permite consultar el estado de visibilidad de la Preview en el ListPage
     */
    get showPreview() {
        return this._showPreview;
    }
    /**
     * Permite activar o desactivar la visibilidad de la Preview en el ListPage
     *
     * @param value Valor que activa o desactiva la visibilidad de la Preview en el ListPage
     */
    set showPreview(value) {
        this._showPreview = value;
    }
    /**
     * Permite obtener el número de columnas que apareceran en el content loader de tipo List Page en el caso de que la List Page
     * esté cargando
     */
    get contentLoaderColumns() {
        return this._contentLoaderColumns;
    }
    /**
     * Permite definir el número de columnas que apareceran en el content loader de tipo List Page en el caso de que la List Page
     * esté cargando
     *
     * @param value El número de columnas que apareceran en el content loader de tipo List Page
     */
    set contentLoaderColumns(value) {
        this._contentLoaderColumns = value;
    }
    /**
     * Permite obtener el contenedor donde estará el content loader
     */
    get contentLoaderContainer() {
        return this._contentLoaderContainer;
    }
    /**
     * Permite definir el contenedor donde estará el content loader
     *
     * @param value El contenedor donde estará el content loader
     */
    set contentLoaderContainer(value) {
        this._contentLoaderContainer = value;
    }
}
ListPageComponent.ɵfac = function ListPageComponent_Factory(t) { return new (t || ListPageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ListPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListPageComponent, selectors: [["ngwk-list-page"]], inputs: { isLoading: "isLoading", showFilters: "showFilters", showPreview: "showPreview", contentLoaderColumns: "contentLoaderColumns", contentLoaderContainer: "contentLoaderContainer" }, ngContentSelectors: _c9, decls: 9, vars: 3, consts: [[1, "listPageGrid", 2, "position", "relative"], [1, "listHeaderGrid"], [1, "toolbarListTitle"], [4, "ngIf"], [1, "listContentGrid"], ["class", "listPreviewGrid", 4, "ngIf"], ["class", "stretchAbsolute", "style", "background: white", 4, "ngIf"], [1, "listPreviewGrid"], [1, "stretchAbsolute", 2, "background", "white"], [3, "columns", "contentLoaderContainer"]], template: function ListPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c8);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, ListPageComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, ListPageComponent_div_7_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(8, ListPageComponent_div_8_Template, 2, 3, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFilters);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPreview);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
    } }, directives: function () { return [ɵngcc1.NgIf, ListPageContentLoaderComponent]; }, styles: ["[_nghost-%COMP%]    {height:100%}[_nghost-%COMP%]     .listPageGrid{display:grid;height:100%;width:100%;grid-template-columns:1fr auto;grid-template-rows:auto 1fr}[_nghost-%COMP%]     .listContentGrid{grid-column:1;grid-row:2;overflow-x:auto}[_nghost-%COMP%]     .listPreviewGrid{grid-column:2;grid-row:2;overflow-y:hidden;overflow-x:hidden}[_nghost-%COMP%]     .listHeaderGrid{grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}[_nghost-%COMP%]     .filterPanel{background-color:#f5f5f5;padding:10px}[_nghost-%COMP%]     .filterPanel .filterContainer{display:flex;flex-wrap:wrap}[_nghost-%COMP%]     .filterPanel .filterInput{width:210px;margin-right:10px}[_nghost-%COMP%]     .filterPanel .filterInput ngwk-floating-label[data-focused] .floatingLabelControl{border-bottom:none!important}[_nghost-%COMP%]     .filterPanel .filterInput ngwk-floating-label[data-focused] .floatingLabelControl .inputLabelContent{border:1px solid #a5a5a5}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl{margin-right:10px;border-bottom:none}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent{border:1px solid #ccc;background-color:#fff;margin-right:10px;max-height:29px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-autocomplete{border-color:transparent}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-autocomplete kendo-searchbar{padding-right:10px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-switch{margin-bottom:0;margin-top:1px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-input{height:29px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent ngwk-text-box input{height:19px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-dropdown-wrap{padding:0!important}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-dropdown-wrap .k-clear-value{height:16px}[_nghost-%COMP%]     .filterPanel .filterInput .floatingLabelControl input{padding:4px}"], data: { animation: [
            trigger('fadeOut', [
                transition(':leave', [
                    animate(1000, style({ opacity: 0 }))
                ])
            ]),
            trigger('filterAnimation', [
                transition(':enter', animate('300ms ease-out', keyframes([
                    style({
                        transform: 'translate3d(0, -15%, 0)',
                        height: '0px',
                        opacity: 0
                    }),
                    style({
                        transform: 'translate3d(0, 0, 0)',
                        height: '82px',
                        opacity: 1
                    }),
                ]))),
                transition(':leave', animate('200ms ease-in', keyframes([
                    style({
                        transform: 'translate3d(0, 0, 0)',
                        height: '82px',
                        opacity: 1
                    }),
                    style({
                        transform: 'translate3d(0, -15%, 0)',
                        height: '0px',
                        opacity: 0
                    }),
                ]))),
            ]),
            trigger('previewAnimation', [
                transition(':enter', animate('500ms ease-out', keyframes([
                    style({
                        transform: 'translate3d(100%, 0, 0)',
                        width: '0px',
                        opacity: 0
                    }),
                    style({
                        transform: 'translate3d(0, 0, 0)',
                        width: '300px',
                        opacity: 1
                    }),
                ]))),
                transition(':leave', animate('400ms ease-in', keyframes([
                    style({
                        transform: 'translate3d(0, 0, 0)',
                        width: '300px',
                        opacity: 1
                    }),
                    style({
                        transform: 'translate3d(100%, 0, 0)',
                        width: '0px',
                        opacity: 0
                    }),
                ]))),
            ]),
        ] } });
/** @nocollapse */
ListPageComponent.ctorParameters = () => [
    { type: ElementRef }
];
ListPageComponent.propDecorators = {
    isLoading: [{ type: Input }],
    showFilters: [{ type: Input }],
    showPreview: [{ type: Input }],
    contentLoaderColumns: [{ type: Input }],
    contentLoaderContainer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListPageComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-list-page',
                template: "<div class=\"listPageGrid\" style=\"position: relative\" >\r\n  <div class=\"listHeaderGrid\">\r\n    <div class=\"toolbarListTitle\">\r\n      <ng-content select=\"list-header\"></ng-content>\r\n    </div>\r\n    <div *ngIf=\"showFilters\" [@filterAnimation]>\r\n      <ng-content select=\"list-filter\"></ng-content>\r\n    </div>\r\n  </div>\r\n  <div class=\"listContentGrid\">\r\n    <ng-content select=\"list-datagrid\"></ng-content>\r\n  </div>\r\n  <div *ngIf=\"showPreview\" class=\"listPreviewGrid\" [@previewAnimation]>\r\n    <ng-content select=\"list-preview\"></ng-content>\r\n  </div>\r\n\r\n  <div *ngIf=\"isLoading\" class=\"stretchAbsolute\" style=\"background: white\" [@fadeOut]>\r\n    <list-page-content-loader\r\n      [columns]=\"contentLoaderColumns\"\r\n      [contentLoaderContainer]=\"contentLoaderContainer\">\r\n    </list-page-content-loader>\r\n  </div>\r\n</div>\r\n",
                animations: [
                    trigger('fadeOut', [
                        transition(':leave', [
                            animate(1000, style({ opacity: 0 }))
                        ])
                    ]),
                    trigger('filterAnimation', [
                        transition(':enter', animate('300ms ease-out', keyframes([
                            style({
                                transform: 'translate3d(0, -15%, 0)',
                                height: '0px',
                                opacity: 0
                            }),
                            style({
                                transform: 'translate3d(0, 0, 0)',
                                height: '82px',
                                opacity: 1
                            }),
                        ]))),
                        transition(':leave', animate('200ms ease-in', keyframes([
                            style({
                                transform: 'translate3d(0, 0, 0)',
                                height: '82px',
                                opacity: 1
                            }),
                            style({
                                transform: 'translate3d(0, -15%, 0)',
                                height: '0px',
                                opacity: 0
                            }),
                        ]))),
                    ]),
                    trigger('previewAnimation', [
                        transition(':enter', animate('500ms ease-out', keyframes([
                            style({
                                transform: 'translate3d(100%, 0, 0)',
                                width: '0px',
                                opacity: 0
                            }),
                            style({
                                transform: 'translate3d(0, 0, 0)',
                                width: '300px',
                                opacity: 1
                            }),
                        ]))),
                        transition(':leave', animate('400ms ease-in', keyframes([
                            style({
                                transform: 'translate3d(0, 0, 0)',
                                width: '300px',
                                opacity: 1
                            }),
                            style({
                                transform: 'translate3d(100%, 0, 0)',
                                width: '0px',
                                opacity: 0
                            }),
                        ]))),
                    ]),
                ],
                styles: [":host ::ng-deep{height:100%}:host ::ng-deep .listPageGrid{display:grid;height:100%;width:100%;grid-template-columns:1fr auto;grid-template-rows:auto 1fr}:host ::ng-deep .listContentGrid{grid-column:1;grid-row:2;overflow-x:auto}:host ::ng-deep .listPreviewGrid{grid-column:2;grid-row:2;overflow-y:hidden;overflow-x:hidden}:host ::ng-deep .listHeaderGrid{grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}:host ::ng-deep .filterPanel{background-color:#f5f5f5;padding:10px}:host ::ng-deep .filterPanel .filterContainer{display:flex;flex-wrap:wrap}:host ::ng-deep .filterPanel .filterInput{width:210px;margin-right:10px}:host ::ng-deep .filterPanel .filterInput ngwk-floating-label[data-focused] .floatingLabelControl{border-bottom:none!important}:host ::ng-deep .filterPanel .filterInput ngwk-floating-label[data-focused] .floatingLabelControl .inputLabelContent{border:1px solid #a5a5a5}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl{margin-right:10px;border-bottom:none}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent{border:1px solid #ccc;background-color:#fff;margin-right:10px;max-height:29px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-autocomplete{border-color:transparent}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-autocomplete kendo-searchbar{padding-right:10px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent kendo-switch{margin-bottom:0;margin-top:1px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-input{height:29px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent ngwk-text-box input{height:19px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-dropdown-wrap{padding:0!important}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl .inputLabelContent .k-dropdown-wrap .k-clear-value{height:16px}:host ::ng-deep .filterPanel .filterInput .floatingLabelControl input{padding:4px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { isLoading: [{
            type: Input
        }], showFilters: [{
            type: Input
        }], showPreview: [{
            type: Input
        }], contentLoaderColumns: [{
            type: Input
        }], contentLoaderContainer: [{
            type: Input
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un content loader de tipo List Page
 *
 * @example
 * <list-page-content-loader
 *  [columns]="columns"
 *  [contentLoaderContainer]="contentLoaderContainer">
 * </list-page-content-loader>
 *
 */
class ListPageContentLoaderComponent extends ContentLoaderComponent {
    //#endregion
    //#region Constructor
    /** @ignore */
    constructor(_el) {
        super();
        this._el = _el;
        //#region Privates
        this._gridWidth = null;
        this._gridHeight = null;
        this._totalLines = null;
        this._columns = 5;
        this._totalColumns = null;
        this._columnWidth = null;
        this._columnMargin = null;
        this._headerColumnWidth = null;
        this._headerColumnMargin = null;
        this._headerColumnPadding = null;
        this._contentLoaderContainer = null;
    }
    //#endregion
    //#region Hooks
    ngOnInit() {
        this.setLinesConfiguration();
        this.setColumnsConfiguration();
    }
    //#endregion
    //#region Methods
    setColumnsConfiguration() {
        this._gridWidth = this.anchorContainer.offsetWidth;
        this._totalColumns = Array(this._columns).fill(0).map((x, i) => i);
        const totalColumnWidth = this._gridWidth / this._totalColumns.length;
        this._columnWidth = totalColumnWidth * 0.75;
        this._columnMargin = totalColumnWidth * 0.25;
        this._headerColumnWidth = totalColumnWidth * 0.50;
        this._headerColumnMargin = 10;
        this._headerColumnPadding = this._headerColumnWidth - 10;
        const totalMarginBetweenColumns = this._totalColumns.length * this._columnMargin;
        this._gridWidth = this._gridWidth - totalMarginBetweenColumns;
        this._columnWidth = this._gridWidth / this._totalColumns.length;
    }
    setLinesConfiguration() {
        this._gridHeight = this.anchorContainer.offsetHeight;
        this._gridHeight = this._gridHeight - 75;
        const lines = Math.trunc(this._gridHeight / 35);
        this._totalLines = Array(lines > 0 ? lines : 0).fill(0).map((x, i) => i);
    }
    /** @ignore */
    readjust() {
        this.setLinesConfiguration();
        this.setColumnsConfiguration();
    }
    //#endregion
    //#region Inputs & Properties
    /**
     * Permite obtener el número total de columnas del content loader
     */
    get columns() {
        return this._columns;
    }
    /**
     * Permite definir el número total de columnas del content loader
     *
     * @param value El número total de columnas del content loader
     */
    set columns(value) {
        this._columns = value;
    }
    /**
     * Permite obtener el contenedor donde estará el content loader
     */
    get contentLoaderContainer() {
        return this._contentLoaderContainer;
    }
    /**
     * Permite definir el contenedor donde estará el content loader
     *
     * @param value El contenedor donde estará el content loader
     */
    set contentLoaderContainer(value) {
        this._contentLoaderContainer = value;
    }
    /** @ignore */
    get anchorContainer() {
        return this.contentLoaderContainer ? this.contentLoaderContainer : this._el.nativeElement.parentNode;
    }
    /** @ignore */
    get totalLines() {
        return this._totalLines;
    }
    /** @ignore */
    get totalColumns() {
        return this._totalColumns;
    }
    /** @ignore */
    get columnWidth() {
        return this._columnWidth;
    }
    /** @ignore */
    get columnMargin() {
        return this._columnMargin;
    }
    /** @ignore */
    get headerColumnWidth() {
        return this._headerColumnWidth;
    }
    /** @ignore */
    get headerColumnMargin() {
        return this._headerColumnMargin;
    }
    /** @ignore */
    get headerColumnPadding() {
        return this._headerColumnPadding;
    }
}
ListPageContentLoaderComponent.ɵfac = function ListPageContentLoaderComponent_Factory(t) { return new (t || ListPageContentLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ListPageContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListPageContentLoaderComponent, selectors: [["list-page-content-loader"]], hostBindings: function ListPageContentLoaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function ListPageContentLoaderComponent_resize_HostBindingHandler() { return ctx.readjust(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { columns: "columns", contentLoaderContainer: "contentLoaderContainer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 17, consts: [[1, "horizontalLayout", "alignVerticalMiddle", "listPageContentLoaderHeader"], [1, "listPageContentLoaderTitle"], [3, "lines", "lineWidth", "lineHeight"], [3, "radius", "cardLines", "lineWidth"], [1, "listPageContentLoaderGrid"], [1, "alignVerticalMiddle", "listPageContentLoaderGridHeaders"], [1, "horizontalLayout"], ["class", "listPageContentLoaderGridHeader", 3, "ngStyle", "lineWidth", "lineHeight", "lines", 4, "ngFor", "ngForOf"], ["class", "alignVerticalMiddle listPageContentLoaderGridLines", 4, "ngFor", "ngForOf"], [1, "listPageContentLoaderGridHeader", 3, "ngStyle", "lineWidth", "lineHeight", "lines"], [1, "alignVerticalMiddle", "listPageContentLoaderGridLines"], [3, "ngStyle", "lineWidth", "lineHeight", "lines", 4, "ngFor", "ngForOf"], [3, "ngStyle", "lineWidth", "lineHeight", "lines"]], template: function ListPageContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "line-content-loader", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "card-content-loader", 3);
        ɵngcc0.ɵɵelement(4, "card-content-loader", 3);
        ɵngcc0.ɵɵelement(5, "card-content-loader", 3);
        ɵngcc0.ɵɵelement(6, "card-content-loader", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵtemplate(10, ListPageContentLoaderComponent_line_content_loader_10_Template, 1, 7, "line-content-loader", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, ListPageContentLoaderComponent_div_11_Template, 3, 1, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("lines", 1)("lineWidth", 120)("lineHeight", 15);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("radius", 14)("cardLines", 0)("lineWidth", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("radius", 14)("cardLines", 0)("lineWidth", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("radius", 14)("cardLines", 0)("lineWidth", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("radius", 14)("cardLines", 0)("lineWidth", 1);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalLines);
    } }, directives: [ɵngcc6.LineContentLoaderComponent, ɵngcc6.CardContentLoaderComponent, ɵngcc1.NgForOf, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]   .listPageContentLoaderHeader[_ngcontent-%COMP%]{margin-left:10px;margin-top:10px;margin-bottom:10px}[_nghost-%COMP%]   .listPageContentLoaderHeader[_ngcontent-%COMP%]   .listPageContentLoaderTitle[_ngcontent-%COMP%]{margin-right:10px}[_nghost-%COMP%]   .listPageContentLoaderGrid[_ngcontent-%COMP%]{margin-left:10px}[_nghost-%COMP%]   .listPageContentLoaderGrid[_ngcontent-%COMP%]   .listPageContentLoaderGridHeaders[_ngcontent-%COMP%]{height:30px;border-bottom:1px solid #e7e7e7}[_nghost-%COMP%]   .listPageContentLoaderGrid[_ngcontent-%COMP%]   .listPageContentLoaderGridHeaders[_ngcontent-%COMP%]   .listPageContentLoaderGridHeader[_ngcontent-%COMP%]{height:30px;border-right:1px solid #e7e7e7}[_nghost-%COMP%]   .listPageContentLoaderGrid[_ngcontent-%COMP%]   .listPageContentLoaderGridLines[_ngcontent-%COMP%]{height:35px;border-bottom:1px solid #e7e7e7}"] });
/** @nocollapse */
ListPageContentLoaderComponent.ctorParameters = () => [
    { type: ElementRef }
];
ListPageContentLoaderComponent.propDecorators = {
    readjust: [{ type: HostListener, args: ['window:resize',] }],
    columns: [{ type: Input }],
    contentLoaderContainer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListPageContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'list-page-content-loader',
                template: "<div class=\"horizontalLayout alignVerticalMiddle listPageContentLoaderHeader\">\r\n  <div class=\"listPageContentLoaderTitle\">\r\n      <line-content-loader [lines]=\"1\" [lineWidth]=\"120\" [lineHeight]=\"15\"></line-content-loader>\r\n  </div>\r\n  <card-content-loader [radius]=\"14\" [cardLines]=\"0\" [lineWidth]=\"1\"></card-content-loader>\r\n  <card-content-loader [radius]=\"14\" [cardLines]=\"0\" [lineWidth]=\"1\"></card-content-loader>\r\n  <card-content-loader [radius]=\"14\" [cardLines]=\"0\" [lineWidth]=\"1\"></card-content-loader>\r\n  <card-content-loader [radius]=\"14\" [cardLines]=\"0\" [lineWidth]=\"1\"></card-content-loader>\r\n</div>\r\n<div class=\"listPageContentLoaderGrid\">\r\n  <div class=\"alignVerticalMiddle listPageContentLoaderGridHeaders\">\r\n    <div class=\"horizontalLayout\">\r\n      <line-content-loader *ngFor=\"let column of totalColumns\" \r\n        class=\"listPageContentLoaderGridHeader\"\r\n        [ngStyle]=\"{ 'margin-right.px': headerColumnMargin, 'padding-right.px': headerColumnPadding }\" \r\n        [lineWidth]=\"headerColumnWidth\" \r\n        [lineHeight]=\"9\" \r\n        [lines]=\"1\">\r\n      </line-content-loader>\r\n    </div>\r\n  </div>\r\n  <div *ngFor=\"let line of totalLines\" class=\"alignVerticalMiddle listPageContentLoaderGridLines\">\r\n    <div class=\"horizontalLayout\">\r\n      <line-content-loader *ngFor=\"let column of totalColumns\" \r\n        [ngStyle]=\"{'margin-right.px': columnMargin}\" \r\n        [lineWidth]=\"columnWidth\" \r\n        [lineHeight]=\"7.5\" \r\n        [lines]=\"1\">\r\n      </line-content-loader>\r\n    </div>\r\n  </div>\r\n</div>",
                styles: [":host .listPageContentLoaderHeader{margin-left:10px;margin-top:10px;margin-bottom:10px}:host .listPageContentLoaderHeader .listPageContentLoaderTitle{margin-right:10px}:host .listPageContentLoaderGrid{margin-left:10px}:host .listPageContentLoaderGrid .listPageContentLoaderGridHeaders{height:30px;border-bottom:1px solid #e7e7e7}:host .listPageContentLoaderGrid .listPageContentLoaderGridHeaders .listPageContentLoaderGridHeader{height:30px;border-right:1px solid #e7e7e7}:host .listPageContentLoaderGrid .listPageContentLoaderGridLines{height:35px;border-bottom:1px solid #e7e7e7}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /** @ignore */
    readjust: [{
            type: HostListener,
            args: ['window:resize']
        }], columns: [{
            type: Input
        }], contentLoaderContainer: [{
            type: Input
        }] }); })();

class ListPageModule {
}
ListPageModule.ɵfac = function ListPageModule_Factory(t) { return new (t || ListPageModule)(); };
ListPageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ListPageModule });
ListPageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ContentLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListPageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ContentLoaderModule
                ],
                declarations: [
                    ListPageComponent,
                    ListPageContentLoaderComponent
                ],
                exports: [
                    ListPageComponent,
                    ListPageContentLoaderComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ListPageModule, { declarations: function () { return [ListPageComponent, ListPageContentLoaderComponent]; }, imports: function () { return [CommonModule,
        ContentLoaderModule]; }, exports: function () { return [ListPageComponent, ListPageContentLoaderComponent]; } }); })();

/**
 * Este componente sirve para declarar un contenido de una página separado por diferentes zonas, entre las cuales se encuentran
 * las zonas de Header, Anchor, Content y Actionbar
 *
 * @example
 * <ngwk-detail-page>
 *      <detail-header>
 *          Header
 *      </detail-header>
 *      <detail-anchor>
 *          Anchor
 *      </detail-anchor>
 *      <detail-content>
 *          Content
 *      </detail-content>
 *      <detail-actionbar>
 *          Actionbar
 *      </detail-actionbar>
 * </ngwk-detail-page>
 */
class DetailPageComponent {
    /**@ignore */
    constructor() { }
}
DetailPageComponent.ɵfac = function DetailPageComponent_Factory(t) { return new (t || DetailPageComponent)(); };
DetailPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DetailPageComponent, selectors: [["ngwk-detail-page"]], ngContentSelectors: _c13, decls: 7, vars: 0, consts: [[1, "detailPageGrid"], [1, "detailAnchorGrid"], [1, "detailContentGrid"], [1, "detailActionBarGrid"]], template: function DetailPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c12);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]    {height:100%}[_nghost-%COMP%]     .detailPageGrid{display:grid;height:100%;width:100%;grid-template-columns:auto 1fr;grid-template-rows:1fr auto}[_nghost-%COMP%]     .detailContentGrid{grid-column:2;grid-row:1;overflow-y:auto;overflow-x:auto}[_nghost-%COMP%]     .detailContentGrid detail-content{display:flex;flex-direction:column;width:100%;height:100%}[_nghost-%COMP%]     .detailAnchorGrid{grid-column:1;grid-row:1;overflow-y:hidden}[_nghost-%COMP%]     .detailActionBarGrid{grid-row:2;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}"] });
/** @nocollapse */
DetailPageComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DetailPageComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-detail-page',
                template: "<div class=\"detailPageGrid\">\r\n    <div class=\"detailAnchorGrid\">\r\n        <ng-content select='detail-anchor'></ng-content>\r\n    </div>\r\n    <div class=\"detailContentGrid\">\r\n        <ng-content select='detail-content'></ng-content>\r\n    </div>\r\n    <div class=\"detailActionBarGrid\">\r\n        <ng-content select='detail-actionbar'></ng-content>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep{height:100%}:host ::ng-deep .detailPageGrid{display:grid;height:100%;width:100%;grid-template-columns:auto 1fr;grid-template-rows:1fr auto}:host ::ng-deep .detailContentGrid{grid-column:2;grid-row:1;overflow-y:auto;overflow-x:auto}:host ::ng-deep .detailContentGrid detail-content{display:flex;flex-direction:column;width:100%;height:100%}:host ::ng-deep .detailAnchorGrid{grid-column:1;grid-row:1;overflow-y:hidden}:host ::ng-deep .detailActionBarGrid{grid-row:2;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}\n"]
            }]
    }], function () { return []; }, null); })();

class DetailPageModule {
}
DetailPageModule.ɵfac = function DetailPageModule_Factory(t) { return new (t || DetailPageModule)(); };
DetailPageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DetailPageModule });
DetailPageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DetailPageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    DetailPageComponent
                ],
                exports: [
                    DetailPageComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DetailPageModule, { declarations: function () { return [DetailPageComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DetailPageComponent]; } }); })();

/** Componente de bienvenida de la aplicación. Se puede definr un título, un mensaje y un botón con contenido y funcionalidad
 *
 * @example
 * <ngwk-welcome
 *  [welcomeTitlePrimary]="welcomeTitlePrimary"
 *  [welcomeTitleSecondary]="welcomeTitleSecondary"
 *  [primaryMessage]="primaryMessage"
 *  [buttonContent]="buttonContent"
 *  (buttonWelcomeClick)="welcomeEvent()">
 * </ngwk-welcome>
 */
class WelcomeComponent {
    /** @ignore */
    constructor() {
        this._welcomeTitlePrimary = 'Bienvenido a';
        this._welcomeTitleSecondary = ' Online Invoicing';
        this._primaryMessage = 'Para empezar a trabajar con la aplicación primero debe configurar la empresa';
        this._buttonContent = 'Configurar Empresa';
        this._buttonWelcomeClick = new EventEmitter();
    }
    /** @ignore */
    onButtonWelcomeClick() {
        this.buttonWelcomeClick.emit();
    }
    /**
     * Permite obtener la primera mitad del título del componente de bienvenida
     */
    get welcomeTitlePrimary() {
        return this._welcomeTitlePrimary;
    }
    /**
     * Permite definir la primera mitad del título del componente de bienvenida
     *
     * @param value La primera mitad del título del componente
     */
    set welcomeTitlePrimary(value) {
        this._welcomeTitlePrimary = value;
    }
    /**
     * Permite obtener la segunda mitad del título del componente de bienvenida
     */
    get welcomeTitleSecondary() {
        return this._welcomeTitleSecondary;
    }
    /**
     * Permite definir la segunda mitad del título del componente de bienvenida
     *
     * @param value La segunda mitad del título del componente
     */
    set welcomeTitleSecondary(value) {
        this._welcomeTitleSecondary = value;
    }
    /**
     * Permite obtener el mensaje principal del componente
     */
    get primaryMessage() {
        return this._primaryMessage;
    }
    /**
     * Permite definir el mensaje principal del componente
     *
     * @param value El mensaje principal del componente
     */
    set primaryMessage(value) {
        this._primaryMessage = value;
    }
    /**
     * Permite obtener el mensaje del botón
     */
    get buttonContent() {
        return this._buttonContent;
    }
    /**
     * Permite definir el mensaje del botón
     *
     * @param value El mensaje del botón
     */
    set buttonContent(value) {
        this._buttonContent = value;
    }
    /**
     * Emite un evento cuando el usuario hace click en el botón
     */
    get buttonWelcomeClick() {
        return this._buttonWelcomeClick;
    }
}
WelcomeComponent.ɵfac = function WelcomeComponent_Factory(t) { return new (t || WelcomeComponent)(); };
WelcomeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WelcomeComponent, selectors: [["ngwk-welcome"]], inputs: { welcomeTitlePrimary: "welcomeTitlePrimary", welcomeTitleSecondary: "welcomeTitleSecondary", primaryMessage: "primaryMessage", buttonContent: "buttonContent" }, outputs: { buttonWelcomeClick: "buttonWelcomeClick" }, decls: 12, vars: 4, consts: [[1, "rowAvailable", "verticalLayout", "alignMiddle", "welcomePage"], [1, "horizontalLayout", "rowAuto", "alignMiddle", "welcomePageTitle"], [1, "welcomeTitlePrimary"], [1, "welcomeTitleSecondary"], [1, "horizontalLayout", "rowAuto", "alignMiddle", "welcomePrimaryText"], [1, "horizontalLayout", "rowAuto", "alignMiddle"], ["id", "btnWelcome", 1, "emptyStateButton", 3, "click"]], template: function WelcomeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "button", 6);
        ɵngcc0.ɵɵlistener("click", function WelcomeComponent_Template_button_click_10_listener() { return ctx.onButtonWelcomeClick(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.welcomeTitlePrimary);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.welcomeTitleSecondary);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.primaryMessage);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.buttonContent);
    } }, styles: ["[_nghost-%COMP%]{height:100%;overflow:hidden}[_nghost-%COMP%]   .welcomePage[_ngcontent-%COMP%]{background:#f5f5f5;padding:16px;height:100%}[_nghost-%COMP%]   .welcomePage[_ngcontent-%COMP%]   .welcomePageTitle[_ngcontent-%COMP%]{font-size:48px;margin-bottom:4px;min-width:650px}[_nghost-%COMP%]   .welcomePage[_ngcontent-%COMP%]   .welcomePageTitle[_ngcontent-%COMP%]   .welcomeTitlePrimary[_ngcontent-%COMP%]{color:#373737;margin-right:13px}[_nghost-%COMP%]   .welcomePage[_ngcontent-%COMP%]   .welcomePageTitle[_ngcontent-%COMP%]   .welcomeTitleSecondary[_ngcontent-%COMP%]{font-size:48px;color:#0081c6;font-family:\"FiraSans Regular\"}[_nghost-%COMP%]   .welcomePage[_ngcontent-%COMP%]   .welcomePrimaryText[_ngcontent-%COMP%]{font-size:20px;color:#0081c6;margin-top:20px;margin-bottom:20px;max-width:600px;text-align:center}"] });
/** @nocollapse */
WelcomeComponent.ctorParameters = () => [];
WelcomeComponent.propDecorators = {
    welcomeTitlePrimary: [{ type: Input }],
    welcomeTitleSecondary: [{ type: Input }],
    primaryMessage: [{ type: Input }],
    buttonContent: [{ type: Input }],
    buttonWelcomeClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WelcomeComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-welcome',
                template: "<div class=\"rowAvailable verticalLayout alignMiddle welcomePage\">\r\n    <div class=\"horizontalLayout rowAuto alignMiddle welcomePageTitle\">\r\n        <span class=\"welcomeTitlePrimary\">{{welcomeTitlePrimary}}</span>\r\n        <span class=\"welcomeTitleSecondary\">{{welcomeTitleSecondary}}</span>\r\n    </div>\r\n    <div class='horizontalLayout rowAuto alignMiddle welcomePrimaryText'>\r\n        <span>{{primaryMessage}}</span>\r\n    </div>\r\n    <div class='horizontalLayout rowAuto alignMiddle'>\r\n        <button id='btnWelcome' class='emptyStateButton' (click)='onButtonWelcomeClick()'>{{buttonContent}}</button>\r\n    </div>\r\n</div>",
                styles: [":host{height:100%;overflow:hidden}:host .welcomePage{background:#f5f5f5;padding:16px;height:100%}:host .welcomePage .welcomePageTitle{font-size:48px;margin-bottom:4px;min-width:650px}:host .welcomePage .welcomePageTitle .welcomeTitlePrimary{color:#373737;margin-right:13px}:host .welcomePage .welcomePageTitle .welcomeTitleSecondary{font-size:48px;color:#0081c6;font-family:\"FiraSans Regular\"}:host .welcomePage .welcomePrimaryText{font-size:20px;color:#0081c6;margin-top:20px;margin-bottom:20px;max-width:600px;text-align:center}\n"]
            }]
    }], function () { return []; }, { welcomeTitlePrimary: [{
            type: Input
        }], welcomeTitleSecondary: [{
            type: Input
        }], primaryMessage: [{
            type: Input
        }], buttonContent: [{
            type: Input
        }], buttonWelcomeClick: [{
            type: Output
        }] }); })();

class WelcomeModule {
}
WelcomeModule.ɵfac = function WelcomeModule_Factory(t) { return new (t || WelcomeModule)(); };
WelcomeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: WelcomeModule });
WelcomeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WelcomeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    WelcomeComponent
                ],
                exports: [
                    WelcomeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WelcomeModule, { declarations: function () { return [WelcomeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [WelcomeComponent]; } }); })();

/**
 * Este componente sirve para declarar un contenido de una página de tipo factura
 * separado por diferentes zonas, entre las cuales se encuentran las zonas de Header, Content y Footer
 *
 * @example
 * <ngwk-document-page>
 *      <document-header>
 *          Header
 *      </document-header>
 *      <document-content>
 *          Content
 *      </document-content>
 *      <document-footer>
 *          Footer
 *      </document-footer>
 * </ngwk-detail-page>
 */
class DocumentPageComponent {
    /**@ignore */
    constructor() {
        this._canShowButton = true;
        this._floatingButtonClick = new EventEmitter();
    }
    /**@ignore */
    onFloatingButtonClick() {
        this.floatingButtonClick.emit();
    }
    //#region Properties
    /**
     * Permite consultar si el botón de la DocumentPage está activado o desactivado
     *
     * @return
     */
    get canShowButton() {
        return this._canShowButton;
    }
    /**
     * Permite activar o desactivar el botón de la DocumentPage
     *
     * @param value Valor que activa o desactiva el botón de la DocumentPage
     * @return
     */
    set canShowButton(value) {
        this._canShowButton = value;
    }
    /**
     * Permite obtener la clase que cambia de color el estilo exterior de la DocumentPage
     *
     * @return
     */
    get colorClass() {
        return this._colorClass;
    }
    /**
     * Permite definir la clase que cambia de color el estilo exterior de la DocumentPage
     *
     * @param value La clase que cambia de color el estilo exterior de la DocumentPage
     * @return
     */
    set colorClass(value) {
        this._colorClass = value;
    }
    /**
     * Permite obtener el icono del botón de la DocumentPage
     *
     * @return
     */
    get floatingButtonIcon() {
        return this._floatingButtonIcon;
    }
    /**
     * Permite definir el icono del botón de la DocumentPage
     *
     * @param value El icono del botón de la DocumentPage
     * @return
     */
    set floatingButtonIcon(value) {
        this._floatingButtonIcon = value;
    }
    /**
     * Permite saber cuando se ha hecho click al botón de la DocumentPage si está activado
     *
     * @return
     */
    get floatingButtonClick() {
        return this._floatingButtonClick;
    }
}
DocumentPageComponent.ɵfac = function DocumentPageComponent_Factory(t) { return new (t || DocumentPageComponent)(); };
DocumentPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DocumentPageComponent, selectors: [["ngwk-document-page"]], inputs: { canShowButton: "canShowButton", colorClass: "colorClass", floatingButtonIcon: "floatingButtonIcon" }, outputs: { floatingButtonClick: "floatingButtonClick" }, ngContentSelectors: _c15, decls: 9, vars: 1, consts: [[1, "documentPageGrid", "verticalLayout"], [1, "documentHeaderGrid", "documentPageContentLoaderWidth", "rowAuto"], ["class", "documentPageButton", 3, "ngClass", "click", 4, "ngIf"], [2, "display", "flex", "justify-content", "flex-end", "margin-right", "-48px"], [1, "documentContentGrid", "documentPageContentLoaderWidth", "verticalLayout", "rowAvailable"], [1, "documentFooterGrid", "documentPageContentLoaderWidth", "rowAuto"], [1, "documentPageButton", 3, "ngClass", "click"], ["iconClass", "componentIcon", 3, "key"]], template: function DocumentPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c14);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DocumentPageComponent_button_2_Template, 2, 2, "button", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵprojection(8, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canShowButton);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc4.IconComponent], styles: ["[_nghost-%COMP%]    {grid-row:2;overflow:auto!important;background-color:#f2f2f2;padding-bottom:10px;height:100%}@media (max-width: 1055px){[_nghost-%COMP%]     .documentPageGrid{margin-left:28px!important}}[_nghost-%COMP%]     .documentPageGrid{border:1px solid;min-width:940px;max-width:80vw;min-height:100%;margin:0 auto;border-top:5px solid;border-color:#555;border-radius:4px;box-shadow:0 3px 17px 1px #87878780;background-color:#fff}[_nghost-%COMP%]     .documentPageGrid .documentHeaderGrid{width:100%;background-color:#fff!important;border-bottom:1px solid #f1f1f1;padding:20px;grid-row:1}[_nghost-%COMP%]     .documentPageGrid .documentPageButton{height:56px;width:56px;top:calc(50% - 28px);left:calc(100% - 28px);border:none;background-color:#555;box-shadow:0 2px 3px #0006;border-radius:100%;position:absolute;cursor:pointer;z-index:50}[_nghost-%COMP%]     .documentPageGrid .documentPageButton ucc-icon i{color:#fff}[_nghost-%COMP%]     .documentPageGrid .documentContentGrid{padding:20px 52px;grid-row:2;border-bottom:1px solid #f1f1f1}[_nghost-%COMP%]     .documentPageGrid .documentContentGrid .ag-body-container{min-height:39px!important}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid{padding:20px;grid-row:3;min-height:190px}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid .totalContentText{font-size:13px;display:flex;justify-content:space-between;margin-bottom:5px;padding:0 17px}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid .totalContentText .totalContentValue{text-align:right}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid .documentTotalZone{display:-webkit-flex;align-items:center;background-color:#edf4f8;margin-top:15px;height:60px;border-radius:5px;padding:0 17px;display:flex;justify-content:space-between}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid .documentTotalZone .documentTotalText{font-family:\"FiraSans Semibold\";color:#555}[_nghost-%COMP%]     .documentPageGrid .documentFooterGrid .documentTotalZone .documentTotalValue{font-family:\"FiraSans Semibold\";color:#0081c6}[_nghost-%COMP%]     .documentPageGrid .documentPageContentLoaderWidth{max-width:79.85vw;min-width:938px}"] });
/** @nocollapse */
DocumentPageComponent.ctorParameters = () => [];
DocumentPageComponent.propDecorators = {
    canShowButton: [{ type: Input }],
    colorClass: [{ type: Input }],
    floatingButtonIcon: [{ type: Input }],
    floatingButtonClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DocumentPageComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-document-page',
                template: "<div class=\"documentPageGrid verticalLayout\">\r\n  <div class=\"documentHeaderGrid documentPageContentLoaderWidth rowAuto\">\r\n      <button class=\"documentPageButton\" *ngIf=\"canShowButton\" [ngClass]=\"colorClass\" (click)=\"onFloatingButtonClick()\">\r\n          <ucc-icon [key]='floatingButtonIcon' iconClass=\"componentIcon\"></ucc-icon>\r\n        </button>\r\n    <ng-content select='document-header'></ng-content>\r\n    <div style=\"display: flex;justify-content: flex-end; margin-right: -48px;\">\r\n    </div>\r\n  </div>\r\n  <div class=\"documentContentGrid documentPageContentLoaderWidth verticalLayout rowAvailable\">\r\n    <ng-content select='document-content'></ng-content>\r\n  </div>\r\n  <div class=\"documentFooterGrid documentPageContentLoaderWidth rowAuto\">\r\n    <ng-content select='document-footer'></ng-content>\r\n  </div>\r\n</div>",
                styles: [":host ::ng-deep{grid-row:2;overflow:auto!important;background-color:#f2f2f2;padding-bottom:10px;height:100%}@media (max-width: 1055px){:host ::ng-deep .documentPageGrid{margin-left:28px!important}}:host ::ng-deep .documentPageGrid{border:1px solid;min-width:940px;max-width:80vw;min-height:100%;margin:0 auto;border-top:5px solid;border-color:#555;border-radius:4px;box-shadow:0 3px 17px 1px #87878780;background-color:#fff}:host ::ng-deep .documentPageGrid .documentHeaderGrid{width:100%;background-color:#fff!important;border-bottom:1px solid #f1f1f1;padding:20px;grid-row:1}:host ::ng-deep .documentPageGrid .documentPageButton{height:56px;width:56px;top:calc(50% - 28px);left:calc(100% - 28px);border:none;background-color:#555;box-shadow:0 2px 3px #0006;border-radius:100%;position:absolute;cursor:pointer;z-index:50}:host ::ng-deep .documentPageGrid .documentPageButton ucc-icon i{color:#fff}:host ::ng-deep .documentPageGrid .documentContentGrid{padding:20px 52px;grid-row:2;border-bottom:1px solid #f1f1f1}:host ::ng-deep .documentPageGrid .documentContentGrid .ag-body-container{min-height:39px!important}:host ::ng-deep .documentPageGrid .documentFooterGrid{padding:20px;grid-row:3;min-height:190px}:host ::ng-deep .documentPageGrid .documentFooterGrid .totalContentText{font-size:13px;display:flex;justify-content:space-between;margin-bottom:5px;padding:0 17px}:host ::ng-deep .documentPageGrid .documentFooterGrid .totalContentText .totalContentValue{text-align:right}:host ::ng-deep .documentPageGrid .documentFooterGrid .documentTotalZone{display:-webkit-flex;align-items:center;background-color:#edf4f8;margin-top:15px;height:60px;border-radius:5px;padding:0 17px;display:flex;justify-content:space-between}:host ::ng-deep .documentPageGrid .documentFooterGrid .documentTotalZone .documentTotalText{font-family:\"FiraSans Semibold\";color:#555}:host ::ng-deep .documentPageGrid .documentFooterGrid .documentTotalZone .documentTotalValue{font-family:\"FiraSans Semibold\";color:#0081c6}:host ::ng-deep .documentPageGrid .documentPageContentLoaderWidth{max-width:79.85vw;min-width:938px}\n"]
            }]
    }], function () { return []; }, { canShowButton: [{
            type: Input
        }], colorClass: [{
            type: Input
        }], floatingButtonIcon: [{
            type: Input
        }], floatingButtonClick: [{
            type: Output
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un content loader de tipo card. Funciona también con un ng-content para definir
 * el contenido del footer, ya que puede variar entre distintos [DocumentPageComponent]{@link DocumentPageComponent}
 *
 * @example
 *   <document-content-loader *ngIf="loading" class="componentHeight" [colorClass]="'document-page'" [floatingButtonIcon]="'equalizer'">
 *       <line-content-loader [lineSeparation]="10" [lines]="1" [lineWidth]="150" [lineHeight]="6"></line-content-loader>
 *       <div class="expirationBoxWaiting">
 *           <line-content-loader [lineSeparation]="20" [lines]="3" [lineWidth]="180" [lineHeight]="8"></line-content-loader>
 *       </div>
 *       <div class="expirationBoxWaiting">
 *           <line-content-loader [lineSeparation]="20" [lines]="3" [lineWidth]="180" [lineHeight]="8"></line-content-loader>
 *       </div>
 *       <div class="expirationBoxWaiting">
 *           <line-content-loader [lineSeparation]="20" [lines]="3" [lineWidth]="180" [lineHeight]="8"></line-content-loader>
 *       </div>
 *   </document-content-loader>
 *
 */
class DocumentContentLoaderComponent {
    constructor() {
        //#region Privates
        this._colorClass = 'document-page';
        this._floatingButtonIcon = 'equalizer';
        this._lineSeparationHeader = 30;
        this._lineSeparationContent = 8;
        this._lineSeparationFooter = 15;
        //#endregion
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite obtener el color del recuadro que contiene en content loader de tipo document, simulando el recuadro que tiene [DocumentPageComponent]{@link DocumentPageComponent}
     * De manera predeterminada tiene la clase 'document-page'.
     *
     * @return
     */
    get colorClass() {
        return this._colorClass;
    }
    /**
     * Permite definir el color del recuadro que contiene en content loader de tipo document, simulando el recuadro que tiene [DocumentPageComponent]{@link DocumentPageComponent}.
     * De manera predeterminada tiene la clase 'document-page'.
     *
     * @param value El color del recuadro que contiene en content loader de tipo document
     * @return
     */
    set colorClass(value) {
        this._colorClass = value;
    }
    /**
     * Permite obtener el icono del content loader de tipo document, simulando el que tiene un [DocumentPageComponent]{@link DocumentPageComponent}
     *
     * @return
     */
    get floatingButtonIcon() {
        return this._floatingButtonIcon;
    }
    /**
     * Permite definir el icono del content loader de tipo document, simulando el que tiene un [DocumentPageComponent]{@link DocumentPageComponent}
     *
     * @param value El icono del content loader de tipo document
     * @return
     */
    set floatingButtonIcon(value) {
        this._floatingButtonIcon = value;
    }
    /**
     * Permite obtener la separación entre las lineas que hay en el header
     *
     * @return
     */
    get lineSeparationHeader() {
        return this._lineSeparationHeader;
    }
    /**
     * Permite definir la separación entre las lineas que hay en el header
     *
     * @param value La separación entre las lineas
     * @return
     */
    set lineSeparationHeader(value) {
        this._lineSeparationHeader = value;
    }
    /**
     * Permite obtener la separación entre las lineas que hay en el content
     *
     * @return
     */
    get lineSeparationContent() {
        return this._lineSeparationContent;
    }
    /**
     * Permite definir la separación entre las lineas que hay en el content
     *
     * @param value La separación entre las lineas
     * @return
     */
    set lineSeparationContent(value) {
        this._lineSeparationContent = value;
    }
    /**
     * Permite obtener la separación entre las lineas que hay en el footer
     *
     * @return
     */
    get lineSeparationFooter() {
        return this._lineSeparationFooter;
    }
    /**
     * Permite definir la separación entre las lineas que hay en el footer
     *
     * @param value La separación entre las lineas
     * @return
     */
    set lineSeparationFooter(value) {
        this._lineSeparationFooter = value;
    }
}
DocumentContentLoaderComponent.ɵfac = function DocumentContentLoaderComponent_Factory(t) { return new (t || DocumentContentLoaderComponent)(); };
DocumentContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DocumentContentLoaderComponent, selectors: [["document-content-loader"]], inputs: { colorClass: "colorClass", floatingButtonIcon: "floatingButtonIcon", lineSeparationHeader: "lineSeparationHeader", lineSeparationContent: "lineSeparationContent", lineSeparationFooter: "lineSeparationFooter" }, ngContentSelectors: _c16, decls: 16, vars: 18, consts: [[1, "componentHeight", 3, "colorClass", "floatingButtonIcon"], [1, "documentHeaderContentLoader"], [3, "lineSeparation", "lines", "lineHeight"], [1, "documentContentContentLoader"], [1, "documentFooterContentLoader", "horizontalLayout"], [1, "leftDocumentFooterContentLoader"], [1, "middleDocumentFooterContentLoader", "rowAvailable"], [1, "rightDocumentFooterContentLoader"], [1, "rightDocumentFooterContentLoaderTotalZone"], [3, "lineSeparation", "lines", "lineWidth", "lineHeight"]], template: function DocumentContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ngwk-document-page", 0);
        ɵngcc0.ɵɵelementStart(1, "document-header");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "line-content-loader", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "document-content");
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelement(6, "line-content-loader", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "document-footer", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelement(9, "line-content-loader", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵprojection(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵelement(13, "line-content-loader", 2);
        ɵngcc0.ɵɵelementStart(14, "div", 8);
        ɵngcc0.ɵɵelement(15, "line-content-loader", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("colorClass", ctx.colorClass)("floatingButtonIcon", ctx.floatingButtonIcon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("lineSeparation", ctx.lineSeparationHeader)("lines", 3)("lineHeight", 15);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("lineSeparation", ctx.lineSeparationContent)("lines", 6)("lineHeight", 20);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("lineSeparation", ctx.lineSeparationFooter)("lines", 6)("lineHeight", 6);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("lineSeparation", ctx.lineSeparationFooter)("lines", 5)("lineHeight", 6);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("lineSeparation", ctx.lineSeparationFooter)("lines", 1)("lineWidth", 300)("lineHeight", 20);
    } }, directives: [DocumentPageComponent, ɵngcc6.LineContentLoaderComponent], styles: ["[_nghost-%COMP%]{height:100%;overflow:auto!important;background-color:#f2f2f2}[_nghost-%COMP%]   .documentHeaderContentLoader[_ngcontent-%COMP%]{margin:10.5px 30px}[_nghost-%COMP%]   .documentContentContentLoader[_ngcontent-%COMP%]{margin-bottom:-10px}[_nghost-%COMP%]   .documentFooterContentLoader[_ngcontent-%COMP%]{margin-right:30px;margin-left:22px;margin-bottom:-15px}[_nghost-%COMP%]   .leftDocumentFooterContentLoader[_ngcontent-%COMP%]{max-width:244px;min-width:244px;margin-left:20px;margin-right:30px}[_nghost-%COMP%]   .rightDocumentFooterContentLoader[_ngcontent-%COMP%]{margin-right:55px;max-width:300px}[_nghost-%COMP%]   .rightDocumentFooterContentLoaderTotalZone[_ngcontent-%COMP%]{display:flex;align-items:center;margin-top:10px;height:60px;border-radius:5px}[_nghost-%COMP%]   .middleDocumentFooterContentLoader[_ngcontent-%COMP%]{min-width:200px;margin-top:-10px}"] });
DocumentContentLoaderComponent.propDecorators = {
    colorClass: [{ type: Input }],
    floatingButtonIcon: [{ type: Input }],
    lineSeparationHeader: [{ type: Input }],
    lineSeparationContent: [{ type: Input }],
    lineSeparationFooter: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DocumentContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'document-content-loader',
                template: "<ngwk-document-page class=\"componentHeight\" [colorClass]=\"colorClass\" [floatingButtonIcon]=\"floatingButtonIcon\">\r\n\r\n  <document-header>\r\n    <div class=\"documentHeaderContentLoader\">\r\n      <line-content-loader [lineSeparation]=\"lineSeparationHeader\" [lines]=\"3\" [lineHeight]=\"15\"></line-content-loader>\r\n    </div>\r\n  </document-header>\r\n\r\n  <document-content>\r\n    <div class=\"documentContentContentLoader\">\r\n      <line-content-loader [lineSeparation]=\"lineSeparationContent\" [lines]=\"6\" [lineHeight]=\"20\"></line-content-loader>\r\n    </div>\r\n  </document-content>\r\n\r\n  <document-footer class=\"documentFooterContentLoader horizontalLayout\">\r\n    <div class=\"leftDocumentFooterContentLoader\">\r\n      <line-content-loader [lineSeparation]=\"lineSeparationFooter\" [lines]=\"6\" [lineHeight]=\"6\"></line-content-loader>\r\n    </div>\r\n    <div class=\"middleDocumentFooterContentLoader rowAvailable\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"rightDocumentFooterContentLoader\">\r\n      <line-content-loader [lineSeparation]=\"lineSeparationFooter\" [lines]=\"5\" [lineHeight]=\"6\"></line-content-loader>\r\n      <div class=\"rightDocumentFooterContentLoaderTotalZone\">\r\n        <line-content-loader [lineSeparation]=\"lineSeparationFooter\" [lines]=\"1\" [lineWidth]=\"300\" [lineHeight]=\"20\"></line-content-loader>\r\n      </div>\r\n    </div>\r\n  </document-footer>\r\n\r\n</ngwk-document-page>",
                styles: [":host{height:100%;overflow:auto!important;background-color:#f2f2f2}:host .documentHeaderContentLoader{margin:10.5px 30px}:host .documentContentContentLoader{margin-bottom:-10px}:host .documentFooterContentLoader{margin-right:30px;margin-left:22px;margin-bottom:-15px}:host .leftDocumentFooterContentLoader{max-width:244px;min-width:244px;margin-left:20px;margin-right:30px}:host .rightDocumentFooterContentLoader{margin-right:55px;max-width:300px}:host .rightDocumentFooterContentLoaderTotalZone{display:flex;align-items:center;margin-top:10px;height:60px;border-radius:5px}:host .middleDocumentFooterContentLoader{min-width:200px;margin-top:-10px}\n"]
            }]
    }], function () { return []; }, { colorClass: [{
            type: Input
        }], floatingButtonIcon: [{
            type: Input
        }], lineSeparationHeader: [{
            type: Input
        }], lineSeparationContent: [{
            type: Input
        }], lineSeparationFooter: [{
            type: Input
        }] }); })();

class DocumentPageModule {
}
DocumentPageModule.ɵfac = function DocumentPageModule_Factory(t) { return new (t || DocumentPageModule)(); };
DocumentPageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DocumentPageModule });
DocumentPageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule,
            ContentLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DocumentPageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule,
                    ContentLoaderModule
                ],
                declarations: [
                    DocumentPageComponent,
                    DocumentContentLoaderComponent
                ],
                exports: [
                    DocumentPageComponent,
                    DocumentContentLoaderComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DocumentPageModule, { declarations: function () { return [DocumentPageComponent, DocumentContentLoaderComponent]; }, imports: function () { return [CommonModule,
        IconModule,
        ContentLoaderModule]; }, exports: function () { return [DocumentPageComponent, DocumentContentLoaderComponent]; } }); })();

/**
 * Este componente funciona a modo de contenedor, donde se le declara un contenido a la izquierda y otro contenido a la derecha
 *
 * @example
 * <ngwk-actionbar>
 *      <actionbar-left>
 *          Content Left
 *      </actionbar-left>
 *      <actionbar-right>
 *          Content Right
 *      </actionbar-right>
 * </ngwk-actionbar>
 */
class ActionbarComponent {
}
ActionbarComponent.ɵfac = function ActionbarComponent_Factory(t) { return new (t || ActionbarComponent)(); };
ActionbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ActionbarComponent, selectors: [["ngwk-actionbar"]], ngContentSelectors: _c18, decls: 5, vars: 0, consts: [[1, "actionBar", "horizontalLayout"], [1, "colAvailable", "alignVerticalMiddle"], [1, "colAuto", "alignVerticalMiddle"]], template: function ActionbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".actionBar[_ngcontent-%COMP%]{height:50px;padding:0 13px;border-top:1px solid #ccc;background-color:#fff}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ActionbarComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-actionbar',
                template: "<div class=\"actionBar horizontalLayout\">\r\n    <div class='colAvailable alignVerticalMiddle'>\r\n        <ng-content select='actionbar-left'></ng-content>\r\n    </div>\r\n    <div class='colAuto alignVerticalMiddle'>\r\n        <ng-content select='actionbar-right'></ng-content>\r\n    </div>\r\n</div>",
                styles: [".actionBar{height:50px;padding:0 13px;border-top:1px solid #ccc;background-color:#fff}\n"]
            }]
    }], null, null); })();

class ActionbarModule {
}
ActionbarModule.ɵfac = function ActionbarModule_Factory(t) { return new (t || ActionbarModule)(); };
ActionbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ActionbarModule });
ActionbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            IconModule,
            TooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ActionbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule,
                    TooltipModule
                ],
                declarations: [
                    ActionbarComponent
                ],
                exports: [
                    ActionbarComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ActionbarModule, { declarations: function () { return [ActionbarComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule,
        TooltipModule]; }, exports: function () { return [ActionbarComponent]; } }); })();

/**
 * Este componente sirve para declarar una página en blanco, la cual incluye un icono informativo, dos textos (uno principal
 * y otro secundario) y un botón con texto y función personalizable
 *
 * @example
 * <ngwk-empty-state
 *  [icon]='icon'
 *  [primaryMessage]='primaryMessage'
 *  [secondaryMessage]='secondaryMessage'
 *  [buttonContent]='buttonContent'
 *  (onLink)='printEvent($event)'>
 * </ngwk-empty-state>
 */
class EmptyStateComponent {
    /**@ignore */
    constructor() {
        this._icon = null;
        this._primaryMessage = null;
        this._secondaryMessage = null;
        this._buttonContent = null;
        this._hasButton = true;
        this._onLink = new EventEmitter();
    }
    /**@ignore */
    onButtonClick() {
        this.onLink.emit();
    }
    /** @ignore */
    isButtonEnabled() {
        return this.hasButton && this.buttonContent !== null;
    }
    /**
     * Permite obtener el valor actual de la propiedad 'icon' del componente EmptyState
     *
     * @return
     */
    get icon() {
        return this._icon;
    }
    /**
     * Permite definir el valor de la propiedad 'icon'
     *
     * @param value Nuevo valor para la propiedad 'icon'
     * @return
     */
    set icon(value) {
        this._icon = value;
    }
    /**
     * Permite obtener el valor actual de la propiedad 'primaryMessage' del componente EmptyState
     *
     * @return
     */
    get primaryMessage() {
        return this._primaryMessage;
    }
    /**
     * Permite definir el valor de la propiedad 'primaryMessage'
     *
     * @param value Nuevo valor para la propiedad 'primaryMessage'
     * @return
     */
    set primaryMessage(value) {
        this._primaryMessage = value;
    }
    /**
     * Permite obtener el valor actual de la propiedad 'secondaryMessage' del componente EmptyState
     *
     * @return
     */
    get secondaryMessage() {
        return this._secondaryMessage;
    }
    /**
     * Permite definir el valor de la propiedad 'secondaryMessage'
     *
     * @param value Nuevo valor para la propiedad 'secondaryMessage'
     * @return
     */
    set secondaryMessage(value) {
        this._secondaryMessage = value;
    }
    /**
     * Permite obtener el valor actual de la propiedad 'buttonContent' del componente EmptyState
     *
     * @return
     */
    get buttonContent() {
        return this._buttonContent;
    }
    /**
     * Permite definir el valor de la propiedad 'buttonContent'
     *
     * @param value Nuevo valor para la propiedad 'buttonContent'
     * @return
     */
    set buttonContent(value) {
        this._buttonContent = value;
    }
    /**
     * Permite activar o desactivar el botón del EmptyState
     *
     * @param value Valor que activa o desactiva el botón del EmptyState
     */
    set hasButton(value) {
        this._hasButton = value;
    }
    /**
     * Permite consultar si el botón del EmptyState está activado o desactivado
     *
     */
    get hasButton() {
        return this._hasButton;
    }
    /**
     * Este Output sirve para emitir un evento en el caso de que se haya definido una función en el botón de la EmptyState
     */
    get onLink() {
        return this._onLink;
    }
}
EmptyStateComponent.ɵfac = function EmptyStateComponent_Factory(t) { return new (t || EmptyStateComponent)(); };
EmptyStateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EmptyStateComponent, selectors: [["ngwk-empty-state"]], inputs: { icon: "icon", primaryMessage: "primaryMessage", secondaryMessage: "secondaryMessage", buttonContent: "buttonContent", hasButton: "hasButton" }, outputs: { onLink: "onLink" }, ngContentSelectors: _c16, decls: 12, vars: 4, consts: [[1, "rowAvailable", "verticalLayout", "alignMiddle", "emptyPage"], [1, "horizontalLayout", "rowAuto", "alignMiddle", "emptyStateIcon"], [3, "key"], [1, "horizontalLayout", "rowAuto", "alignMiddle", "emptyStatePrimaryText"], [1, "horizontalLayout", "rowAuto", "alignMiddle", "emptyStateText"], ["class", "horizontalLayout rowAuto alignMiddle", 4, "ngIf"], [1, "alignMiddle"], [1, "horizontalLayout", "rowAuto", "alignMiddle"], [1, "emptyStateButton", 3, "click"]], template: function EmptyStateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ucc-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, EmptyStateComponent_div_9_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵprojection(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("key", ctx.icon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.primaryMessage);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.secondaryMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isButtonEnabled());
    } }, directives: [ɵngcc4.IconComponent, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]   .emptyPage[_ngcontent-%COMP%]{background:#f5f5f5;padding:16px;height:100%}"] });
/** @nocollapse */
EmptyStateComponent.ctorParameters = () => [];
EmptyStateComponent.propDecorators = {
    icon: [{ type: Input }],
    primaryMessage: [{ type: Input }],
    secondaryMessage: [{ type: Input }],
    buttonContent: [{ type: Input }],
    hasButton: [{ type: Input }],
    onLink: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmptyStateComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-empty-state',
                template: "<div class=\"rowAvailable verticalLayout alignMiddle emptyPage\">\r\n    <div class='horizontalLayout rowAuto alignMiddle emptyStateIcon'>\r\n        <ucc-icon [key]='icon'></ucc-icon>\r\n    </div>\r\n    <div class='horizontalLayout rowAuto alignMiddle emptyStatePrimaryText'>\r\n        <span>{{primaryMessage}}</span>\r\n    </div>\r\n    <div class='horizontalLayout rowAuto alignMiddle emptyStateText'>\r\n        <span>{{secondaryMessage}}</span>\r\n    </div>\r\n    <div *ngIf='isButtonEnabled()' class='horizontalLayout rowAuto alignMiddle'>\r\n        <button class='emptyStateButton' (click)='onButtonClick()'>{{buttonContent}}</button>\r\n    </div>\r\n    <div class='alignMiddle'>\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n",
                styles: [":host .emptyPage{background:#f5f5f5;padding:16px;height:100%}\n"]
            }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], primaryMessage: [{
            type: Input
        }], secondaryMessage: [{
            type: Input
        }], buttonContent: [{
            type: Input
        }], hasButton: [{
            type: Input
        }], onLink: [{
            type: Output
        }] }); })();

class EmptyStateModule {
}
EmptyStateModule.ɵfac = function EmptyStateModule_Factory(t) { return new (t || EmptyStateModule)(); };
EmptyStateModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EmptyStateModule });
EmptyStateModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmptyStateModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    EmptyStateComponent
                ],
                exports: [
                    EmptyStateComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EmptyStateModule, { declarations: function () { return [EmptyStateComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [EmptyStateComponent]; } }); })();

/** @ignore */
class ErrorPageComponent {
    constructor(_localeService) {
        this._localeService = _localeService;
    }
}
ErrorPageComponent.ɵfac = function ErrorPageComponent_Factory(t) { return new (t || ErrorPageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocaleService)); };
ErrorPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ErrorPageComponent, selectors: [["ngwk-error-page"]], decls: 7, vars: 3, consts: [[1, "stretchContainer", "alignMiddle", "errorPageBg"], [1, "verticalLayout", "errorPageContent"], [1, "alignMiddle", "rowAuto"], ["src", "framework/assets/images/LOL_face.svg", 1, "errorPageIcon"], [1, "alignMiddle", "rowAuto", "errorPageHighlightedText"]], template: function ErrorPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 1, "error_page_message"));
    } }, pipes: [ɵngcc5.LocalePipe], styles: ["[_nghost-%COMP%]     .strechContainer, [_nghost-%COMP%]     .stretchContainer{height:100%;width:100%}[_nghost-%COMP%]     .errorPageBg{background-color:#f1f1f1}[_nghost-%COMP%]     .errorPageContent{margin:0 1rem;text-align:center}[_nghost-%COMP%]     .errorPageHighlightedText{font-size:1.375rem;color:#0081c6}[_nghost-%COMP%]     .errorPageIcon{margin-bottom:1rem;margin-left:16px}"] });
/** @nocollapse */
ErrorPageComponent.ctorParameters = () => [
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorPageComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-error-page',
                template: "<div class=\"stretchContainer alignMiddle errorPageBg\">\r\n    <div class=\"verticalLayout errorPageContent\">\r\n        <div class=\"alignMiddle rowAuto\">\r\n            <img src=\"framework/assets/images/LOL_face.svg\" class=\"errorPageIcon\" />\r\n        </div>\r\n        <p class=\"alignMiddle rowAuto errorPageHighlightedText\">{{ 'error_page_message' | locale }}</p>       \r\n    </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .strechContainer,:host ::ng-deep .stretchContainer{height:100%;width:100%}:host ::ng-deep .errorPageBg{background-color:#f1f1f1}:host ::ng-deep .errorPageContent{margin:0 1rem;text-align:center}:host ::ng-deep .errorPageHighlightedText{font-size:1.375rem;color:#0081c6}:host ::ng-deep .errorPageIcon{margin-bottom:1rem;margin-left:16px}\n"]
            }]
    }], function () { return [{ type: ɵngcc5.LocaleService }]; }, null); })();

class ErrorPageModule {
}
ErrorPageModule.ɵfac = function ErrorPageModule_Factory(t) { return new (t || ErrorPageModule)(); };
ErrorPageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ErrorPageModule });
ErrorPageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LocalizationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorPageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    LocalizationModule
                ],
                declarations: [
                    ErrorPageComponent
                ],
                exports: [
                    ErrorPageComponent
                ],
                entryComponents: [
                    ErrorPageComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ErrorPageModule, { declarations: function () { return [ErrorPageComponent]; }, imports: function () { return [CommonModule,
        LocalizationModule]; }, exports: function () { return [ErrorPageComponent]; } }); })();

/**
 * Este componente sirve para declarar la cabecera de una ListPage
 *
 * @example
 * <ngwk-list-header
 *  [title]="title"
 *  (search)="onSearch($event)">
 * </ngwk-list-header>
 *
 */
class ListHeaderComponent {
    /** @ignore */
    constructor(_localeService) {
        this._localeService = _localeService;
        this._title = null;
        this._textValue = '';
        this._placeholderSearch = this._localeService.getLocaleString('placeholder_search');
        this._showSearchBox = true;
        this._search = new EventEmitter();
    }
    /** @ignore */
    get textValue() {
        return this._textValue;
    }
    /** @ignore */
    onSearch(value) {
        let searchValue = value ? value.trim() : value;
        if (searchValue || searchValue === '') {
            this.search.emit(searchValue);
        }
    }
    /** @ignore */
    onClear() {
        this.search.emit('');
    }
    /** @ignore */
    set textValue(value) {
        this._textValue = value;
    }
    /**
     * Permite obtener el título del ListHeader
     */
    get title() {
        return this._title;
    }
    /**
     * Permite definir el título del ListHeader
     *
     * @param value El título del ListHeader
     */
    set title(value) {
        this._title = value;
    }
    /**
     * Permite obtener el placeholder del Input de búsqueda del ListHeader
     */
    get placeholderSearch() {
        return this._placeholderSearch;
    }
    /**
     * Permite definir el placeholder del Input de búsqueda del ListHeader
     *
     * @param value El placeholder del Input de búsqueda del ListHeader
     */
    set placeholderSearch(value) {
        this._placeholderSearch = value;
    }
    /**
     * Permite consultar si el Searchbox del List Header está activado o desactivado
     */
    get showSearchBox() {
        return this._showSearchBox;
    }
    /**
     * Permite activar o desactivar el Searchbox de búsqueda del ListHeader
     *
     * @param value Valor que activa o desactiva el Input de búsqueda del ListHeader
     */
    set showSearchBox(value) {
        this._showSearchBox = value;
    }
    /**
     * Permite saber cuando se ha hecho click al botón de búscar del Input de búsqueda del ListHeader
     */
    get search() {
        return this._search;
    }
}
ListHeaderComponent.ɵfac = function ListHeaderComponent_Factory(t) { return new (t || ListHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocaleService)); };
ListHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListHeaderComponent, selectors: [["ngwk-list-header"]], inputs: { title: "title", placeholderSearch: "placeholderSearch", showSearchBox: "showSearchBox" }, outputs: { search: "search" }, ngContentSelectors: _c20, decls: 6, vars: 2, consts: [[1, "rowAuto", "horizontalLayout", "alignVerticalMiddle"], [1, "colAvailable", "horizontalLayout", "alignVerticalMiddle"], [1, "titleSection"], [3, "placeholder", "search", "clear", 4, "ngIf"], [3, "placeholder", "search", "clear"]], template: function ListHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c19);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h3", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ListHeaderComponent_ngwk_search_box_5_Template, 1, 1, "ngwk-search-box", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSearchBox);
    } }, directives: [ɵngcc1.NgIf, ɵngcc7.SearchBoxComponent], encapsulation: 2 });
/** @nocollapse */
ListHeaderComponent.ctorParameters = () => [
    { type: LocaleService }
];
ListHeaderComponent.propDecorators = {
    title: [{ type: Input }],
    placeholderSearch: [{ type: Input }],
    showSearchBox: [{ type: Input }],
    search: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-list-header',
                template: "<div class='rowAuto horizontalLayout alignVerticalMiddle'>\r\n    <div class='colAvailable horizontalLayout alignVerticalMiddle'>\r\n        <h3 class=\"titleSection\">{{title}}</h3>\r\n        <ng-content select='list-header-content'></ng-content>\r\n    </div>\r\n    <ngwk-search-box *ngIf=\"showSearchBox\"\r\n        [placeholder]=\"placeholderSearch\"\r\n        (search)=\"onSearch($event)\" \r\n        (clear)=\"onClear()\">\r\n    </ngwk-search-box>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc5.LocaleService }]; }, { title: [{
            type: Input
        }], placeholderSearch: [{
            type: Input
        }], showSearchBox: [{
            type: Input
        }], search: [{
            type: Output
        }] }); })();

class ListHeaderModule {
}
ListHeaderModule.ɵfac = function ListHeaderModule_Factory(t) { return new (t || ListHeaderModule)(); };
ListHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ListHeaderModule });
ListHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            IconModule,
            TooltipModule,
            InputsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule,
                    TooltipModule,
                    InputsModule
                ],
                declarations: [
                    ListHeaderComponent
                ],
                exports: [
                    ListHeaderComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ListHeaderModule, { declarations: function () { return [ListHeaderComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule,
        TooltipModule,
        InputsModule]; }, exports: function () { return [ListHeaderComponent]; } }); })();

/**
 * Este componente sirve para la declaración de una página de tipo Login
 * Se le puede añadir contenido extra que se posicionará justo encima del formulario de login
 *
 * @example
 * <ngwk-login
 *  [errors]="errors"
 *  [isLoading]="isLoading"
 *  (login)="onLogin($event)"
 *  (openTermsOfUse)="onOpenTermsOfUse()"
 *  (recoverPassword)="onRecoverPassword()">
 *
 *  Content
 *
 * </ngwk-login>
 */
class LoginComponent {
    constructor() {
        //#region Privates
        this._email = null;
        this._password = null;
        this._isLoading = false;
        this._canValidate = false;
        this._errors = null;
        this._login = new EventEmitter();
        this._openTermsOfUse = new EventEmitter();
        this._recoverPassword = new EventEmitter();
        //#endregion
    }
    //#endregion
    //#region Hooks
    ngAfterViewInit() {
        setTimeout(() => this._emailTextbox.focus());
    }
    //#endregion
    //#region Action Methods
    /** @ignore */
    onOpenTermsOfUse() {
        this.openTermsOfUse.emit();
    }
    /** @ignore */
    onRecoverPassword() {
        this.recoverPassword.emit();
    }
    /** @ignore */
    onLoginCredentials(event) {
        this._canValidate = true;
        if (!this.isLoading) {
            // FIX: Force focus on button to avoid the error ExpressionChangedAfterItHasBeenCheckedError when launch login from enter key in password box.
            this._btnLogin.nativeElement.focus();
            let userEmail = this.email ? this.email.trim() : this.email;
            let userPassword = this.password ? this.password.trim() : this.password;
            if (userEmail && userPassword) {
                let loginCredentials = { email: userEmail, password: userPassword };
                this.login.emit(loginCredentials);
            }
        }
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    get canValidate() {
        return this._canValidate;
    }
    //#region Properties
    /** @ignore */
    get email() {
        return this._email;
    }
    /** @ignore */
    set email(value) {
        this._email = value;
    }
    /** @ignore */
    get password() {
        return this._password;
    }
    /** @ignore */
    set password(value) {
        this._password = value;
    }
    /**
     * Permite consultar si el login está cargando o no
     */
    get isLoading() {
        return this._isLoading;
    }
    /**
     * Permite activar o desactivar la propiedad de cargando datos del Login
     *
     * @param value Valor que activa o desactiva la propiedad de cargando datos del Login
     */
    set isLoading(value) {
        this._isLoading = value;
    }
    /**
     * Permite obtener los errores personalizables del Login
     */
    get errors() {
        return this._errors;
    }
    /**
     * Permite definir los errores personalizables del Login
     *
     * @param value Los errores personalizables del Login
     */
    set errors(value) {
        this._errors = value;
    }
    /**
     * Permite saber cuando se ha hecho click a la label de abrir términos de uso a través de un evento
     */
    get openTermsOfUse() {
        return this._openTermsOfUse;
    }
    /**
     * Permite saber cuando se ha hecho click a la label de recuperar contraseña a través de un evento
     */
    get recoverPassword() {
        return this._recoverPassword;
    }
    /**
     * Permite saber cuando se ha hecho click al botón de logear a través de un evento
     */
    get login() {
        return this._login;
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(); };
LoginComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["ngwk-login"]], viewQuery: function LoginComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c21, 7);
        ɵngcc0.ɵɵviewQuery(_c22, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._btnLogin = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._emailTextbox = _t.first);
    } }, inputs: { isLoading: "isLoading", errors: "errors" }, outputs: { openTermsOfUse: "openTermsOfUse", recoverPassword: "recoverPassword", login: "login" }, ngContentSelectors: _c16, decls: 37, vars: 27, consts: [[1, "loginPage", "alignMiddle"], [1, "loginLeft", "flexDirectionColumn"], [1, "woltersLogo"], ["src", "framework/assets/images/wkLogo.svg", "alt", "Wolters Kluwer"], [1, "loginContainer"], ["class", "errorsText", 4, "ngIf"], [1, "headerLoginFormContainer"], [1, "loginBox"], ["action", "", "autocomplete", "off", "method", "POST", 1, "loginForm", 3, "submit"], ["loginForm", "ngForm"], [1, "loginEmailBox"], ["fixedLabel", "true", 3, "label"], ["id", "txtUsername", "name", "email", "autocomplete", "username", 3, "ngModel", "required", "ngModelChange"], ["emailTextbox", ""], [1, "loginPasswordBox"], ["id", "txtPassword", "name", "password", "autocomplete", "current-password", 3, "ngModel", "required", "ngModelChange"], [1, "loginRecoveryPass"], [3, "click"], [1, "loginSesionButton"], ["type", "submit", "id", "btnLogin", 1, "buttonPrimary", 3, "disabled", "ngWKProgressButton"], ["btnLogin", ""], [1, "footerText"], [1, "loginRight"], [1, "errorsText"], ["class", "horizontalLayout", 4, "ngFor", "ngForOf"], [1, "horizontalLayout"], ["cardType", "error", 3, "message"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, LoginComponent_div_5_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "form", 8, 9);
        ɵngcc0.ɵɵlistener("submit", function LoginComponent_Template_form_submit_9_listener() { return ctx.onLoginCredentials(); });
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "ngwk-floating-label", 11);
        ɵngcc0.ɵɵpipe(13, "locale");
        ɵngcc0.ɵɵelementStart(14, "ngwk-text-box", 12, 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function LoginComponent_Template_ngwk_text_box_ngModelChange_14_listener($event) { return ctx.email = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 14);
        ɵngcc0.ɵɵelementStart(17, "ngwk-floating-label", 11);
        ɵngcc0.ɵɵpipe(18, "locale");
        ɵngcc0.ɵɵelementStart(19, "ngwk-password-box", 15);
        ɵngcc0.ɵɵlistener("ngModelChange", function LoginComponent_Template_ngwk_password_box_ngModelChange_19_listener($event) { return ctx.password = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 16);
        ɵngcc0.ɵɵelementStart(21, "span", 17);
        ɵngcc0.ɵɵlistener("click", function LoginComponent_Template_span_click_21_listener() { return ctx.onRecoverPassword(); });
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 18);
        ɵngcc0.ɵɵelementStart(25, "button", 19, 20);
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 21);
        ɵngcc0.ɵɵelementStart(30, "span");
        ɵngcc0.ɵɵtext(31);
        ɵngcc0.ɵɵpipe(32, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "a", 17);
        ɵngcc0.ɵɵlistener("click", function LoginComponent_Template_a_click_33_listener() { return ctx.onOpenTermsOfUse(); });
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(36, "div", 22);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(13, 15, "email"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.email)("required", ctx.canValidate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(18, 17, "password"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.password)("required", ctx.canValidate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(23, 19, "recover_password"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.isLoading)("ngWKProgressButton", ctx.isLoading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(28, 21, "login_button"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(32, 23, "company_copyright"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(35, 25, "terms_of_use"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background-image", "url(framework/assets/images/login-image.jpg)");
    } }, directives: [ɵngcc1.NgIf, ɵngcc8.ɵNgNoValidate, ɵngcc8.NgControlStatusGroup, ɵngcc8.NgForm, ɵngcc7.FloatingLabelComponent, ɵngcc7.TextBoxComponent, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, ɵngcc8.RequiredValidator, ɵngcc7.PasswordBoxComponent, ɵngcc9.ProgressButtonDirective, ɵngcc1.NgForOf, ɵngcc10.AlertCardComponent], pipes: [ɵngcc5.LocalePipe], styles: ["[_nghost-%COMP%]    {height:100%;width:100%;display:flex;align-items:center;justify-content:center}[_nghost-%COMP%]     .loginPage{display:flex;position:relative;width:100%;height:100%}[_nghost-%COMP%]     .loginPage .woltersLogo{font-size:16px;position:absolute;top:32px;left:14px}[_nghost-%COMP%]     .loginPage .loginLeft{display:flex;width:50%;justify-content:center}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer{display:flex;align-items:center;flex-direction:column}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .headerLoginFormContainer{display:flex;flex-direction:column;margin-bottom:20px;align-items:center}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox{height:325px;width:470px;background-color:#ededed;padding:21px 16px 15px 15px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl{border-bottom:0px!important}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer{margin-bottom:5px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer label{font-size:13px;color:#373737;margin-bottom:3px;font-size:16px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer .floatingWarningIcon{margin:1px 1px 5px 5px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox{margin-bottom:10px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox ngwk-text-box{display:flex}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox ngwk-text-box input{box-sizing:border-box;border:1px solid #ccc!important;background-color:#fff!important;height:45px;width:100%;font-size:16px;padding:0 15px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox{margin-bottom:15px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox ngwk-password-box{display:flex}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox ngwk-password-box input{box-sizing:border-box;border:1px solid #ccc!important;background-color:#fff!important;height:45px;width:100%;font-size:16px;padding:0 15px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginRecoveryPass{color:#0081c6;font-size:15px;cursor:pointer}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton{display:flex;padding-top:25px;justify-content:center}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button{user-select:none;cursor:pointer;border-radius:2px;text-transform:uppercase;font-size:13px;font-family:FiraSans Regular,Verdana;width:auto;height:31px;outline:none;box-shadow:none;transition:.1s;overflow:hidden;min-width:100px;background-image:none;background-color:#0081c6;border:1px solid transparent;color:#fff;padding-right:15px;padding-left:15px;margin:4px;height:55px!important;width:100%!important;border-radius:4px!important;font-size:16px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button:focus{background-color:#00a2f9}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button:hover{background-color:#2db6ff}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button[disabled]{color:#fff;cursor:default;background-color:#ccc;border:1px solid transparent}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label[data-focused] .floatingLabelControl{border-bottom:0px}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label[data-focused] .floatingLabelControl input{box-sizing:border-box;border:1px solid #66afe9!important;box-shadow:inset 0 1px 1px #00000013,0 0 8px #66afe999}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .errorsText{max-width:470px;padding-bottom:20px;color:#aaa}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .footerText{text-align:center;font-size:11px;margin-top:5px;color:#ccc}[_nghost-%COMP%]     .loginPage .loginLeft .loginContainer .footerText a{cursor:pointer;color:#0081c6}[_nghost-%COMP%]     .loginPage .loginRight{display:flex;width:50%;height:100%;background-position:center!important;background-size:cover}@media (min-width: 0px) and (max-width: 1050px){[_nghost-%COMP%]     .loginPage{display:flex}[_nghost-%COMP%]     .loginPage .loginRight{display:none}}"] });
LoginComponent.propDecorators = {
    _btnLogin: [{ type: ViewChild, args: ["btnLogin", { static: true },] }],
    _emailTextbox: [{ type: ViewChild, args: ["emailTextbox", { static: true },] }],
    isLoading: [{ type: Input }],
    errors: [{ type: Input }],
    openTermsOfUse: [{ type: Output }],
    recoverPassword: [{ type: Output }],
    login: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-login",
                template: "<div class=\"loginPage alignMiddle\">\r\n  <div class=\"loginLeft flexDirectionColumn\">\r\n    <div class=\"woltersLogo\">\r\n      <img src=\"framework/assets/images/wkLogo.svg\" alt=\"Wolters Kluwer\">\r\n    </div>\r\n\r\n    <div class=\"loginContainer\">\r\n\r\n      <div *ngIf=\"errors\" class=\"errorsText\">\r\n        <div *ngFor=\"let error of errors\" class=\"horizontalLayout\">\r\n\r\n            <ucc-alert-card cardType=\"error\"\r\n                            message=\"{{ error }}\">\r\n            </ucc-alert-card>\r\n            \r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"headerLoginFormContainer\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n   \r\n      <div class=\"loginBox\">\r\n        <form class=\"loginForm\" #loginForm=\"ngForm\" action=\"\" (submit)=\"onLoginCredentials()\" autocomplete=\"off\" method=\"POST\">\r\n          <div class=\"loginEmailBox\">\r\n            <ngwk-floating-label label=\"{{ 'email' | locale }}\" fixedLabel=\"true\">\r\n              <ngwk-text-box #emailTextbox [(ngModel)]=\"email\" id=\"txtUsername\" name=\"email\" [required]=\"canValidate\" autocomplete=\"username\"></ngwk-text-box>\r\n            </ngwk-floating-label>\r\n          </div>\r\n          <div class=\"loginPasswordBox\">\r\n            <ngwk-floating-label label=\"{{ 'password' | locale }}\" fixedLabel=\"true\">\r\n              <ngwk-password-box [(ngModel)]=\"password\" id=\"txtPassword\" name=\"password\" autocomplete=\"current-password\"\r\n              [required]=\"canValidate\"></ngwk-password-box>\r\n            </ngwk-floating-label>\r\n          </div>\r\n          <div class=\"loginRecoveryPass\">\r\n            <span (click)=\"onRecoverPassword()\">\r\n              {{'recover_password' | locale}}\r\n            </span>\r\n          </div>\r\n          <div class=\"loginSesionButton\">\r\n            <button type=\"submit\" #btnLogin class=\"buttonPrimary\" [disabled]=\"isLoading\" id=\"btnLogin\"\r\n              [ngWKProgressButton]=\"isLoading\">\r\n              {{'login_button' | locale}}\r\n            </button>\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <div class=\"footerText\">\r\n        <span>\r\n          {{'company_copyright' | locale}}\r\n        </span>\r\n        <a (click)=\"onOpenTermsOfUse()\">\r\n          {{'terms_of_use' | locale}}\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"loginRight\" [style.background-image]=\"'url(framework/assets/images/login-image.jpg)'\">\r\n\r\n  </div>\r\n</div>",
                styles: [":host ::ng-deep{height:100%;width:100%;display:flex;align-items:center;justify-content:center}:host ::ng-deep .loginPage{display:flex;position:relative;width:100%;height:100%}:host ::ng-deep .loginPage .woltersLogo{font-size:16px;position:absolute;top:32px;left:14px}:host ::ng-deep .loginPage .loginLeft{display:flex;width:50%;justify-content:center}:host ::ng-deep .loginPage .loginLeft .loginContainer{display:flex;align-items:center;flex-direction:column}:host ::ng-deep .loginPage .loginLeft .loginContainer .headerLoginFormContainer{display:flex;flex-direction:column;margin-bottom:20px;align-items:center}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox{height:325px;width:470px;background-color:#ededed;padding:21px 16px 15px 15px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl{border-bottom:0px!important}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer{margin-bottom:5px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer label{font-size:13px;color:#373737;margin-bottom:3px;font-size:16px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label .floatingLabelControl .floatingLabelContainer .floatingWarningIcon{margin:1px 1px 5px 5px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox{margin-bottom:10px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox ngwk-text-box{display:flex}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginEmailBox ngwk-text-box input{box-sizing:border-box;border:1px solid #ccc!important;background-color:#fff!important;height:45px;width:100%;font-size:16px;padding:0 15px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox{margin-bottom:15px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox ngwk-password-box{display:flex}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginPasswordBox ngwk-password-box input{box-sizing:border-box;border:1px solid #ccc!important;background-color:#fff!important;height:45px;width:100%;font-size:16px;padding:0 15px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginRecoveryPass{color:#0081c6;font-size:15px;cursor:pointer}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton{display:flex;padding-top:25px;justify-content:center}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button{user-select:none;cursor:pointer;border-radius:2px;text-transform:uppercase;font-size:13px;font-family:FiraSans Regular,Verdana;width:auto;height:31px;outline:none;box-shadow:none;transition:.1s;overflow:hidden;min-width:100px;background-image:none;background-color:#0081c6;border:1px solid transparent;color:#fff;padding-right:15px;padding-left:15px;margin:4px;height:55px!important;width:100%!important;border-radius:4px!important;font-size:16px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button:focus{background-color:#00a2f9}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button:hover{background-color:#2db6ff}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox .loginSesionButton button[disabled]{color:#fff;cursor:default;background-color:#ccc;border:1px solid transparent}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label[data-focused] .floatingLabelControl{border-bottom:0px}:host ::ng-deep .loginPage .loginLeft .loginContainer .loginBox ngwk-floating-label[data-focused] .floatingLabelControl input{box-sizing:border-box;border:1px solid #66afe9!important;box-shadow:inset 0 1px 1px #00000013,0 0 8px #66afe999}:host ::ng-deep .loginPage .loginLeft .loginContainer .errorsText{max-width:470px;padding-bottom:20px;color:#aaa}:host ::ng-deep .loginPage .loginLeft .loginContainer .footerText{text-align:center;font-size:11px;margin-top:5px;color:#ccc}:host ::ng-deep .loginPage .loginLeft .loginContainer .footerText a{cursor:pointer;color:#0081c6}:host ::ng-deep .loginPage .loginRight{display:flex;width:50%;height:100%;background-position:center!important;background-size:cover}@media (min-width: 0px) and (max-width: 1050px){:host ::ng-deep .loginPage{display:flex}:host ::ng-deep .loginPage .loginRight{display:none}}\n"]
            }]
    }], function () { return []; }, { isLoading: [{
            type: Input
        }], errors: [{
            type: Input
        }], openTermsOfUse: [{
            type: Output
        }], recoverPassword: [{
            type: Output
        }], login: [{
            type: Output
        }], _btnLogin: [{
            type: ViewChild,
            args: ["btnLogin", { static: true }]
        }], _emailTextbox: [{
            type: ViewChild,
            args: ["emailTextbox", { static: true }]
        }] }); })();

class LoginModule {
}
LoginModule.ɵfac = function LoginModule_Factory(t) { return new (t || LoginModule)(); };
LoginModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoginModule });
LoginModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            InputsModule,
            IconModule,
            ProgressButtonModule,
            LocalizationModule,
            UccDrawingModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoginModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    InputsModule,
                    IconModule,
                    ProgressButtonModule,
                    LocalizationModule,
                    UccDrawingModule
                ],
                declarations: [
                    LoginComponent
                ],
                exports: [
                    LoginComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoginModule, { declarations: function () { return [LoginComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        InputsModule,
        IconModule,
        ProgressButtonModule,
        LocalizationModule,
        UccDrawingModule]; }, exports: function () { return [LoginComponent]; } }); })();

/**
 * Este servicio sirve para la gestión de modales de tipo Wizard en la aplicación. Se le debe pasar un componente que implemente
 * un [WizardModalComponent]{@link WizardModalComponent} con cada uno de sus Inputs obligatorios, como los steps, el titulo, y
 * el funcionamiento de cada uno de los botones de la modal (Next, Previous, Close y Discard).
 */
class WizardService {
    /** @ignore */
    constructor(_modalService) {
        this._modalService = _modalService;
        this._activeWizard = null;
    }
    /**
     * Método que abre un Wizard Modal. Se le debe pasar un componente custom que implemente un [WizardModalComponent]{@link WizardModalComponent}
     * @param customComponent Componente custom que implementa un [WizardModalComponent]{@link WizardModalComponent}
     */
    open(customComponent) {
        let options = {
            canClose: false,
            windowClass: 'wizardModalWrapper',
            size: 'lg'
        };
        this._activeWizard = this._modalService.showCustom(customComponent, options);
    }
    get activeWizard() {
        return this._activeWizard;
    }
}
WizardService.ɵfac = function WizardService_Factory(t) { return new (t || WizardService)(ɵngcc0.ɵɵinject(ɵngcc11.ModalService)); };
WizardService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WizardService, factory: WizardService.ɵfac });
/** @nocollapse */
WizardService.ctorParameters = () => [
    { type: ModalService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WizardService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.ModalService }]; }, null); })();

/**
 * Este servicio sirve para la gestión del Wizard Modal. El usuario, en la implementación de los botones del Wizard Modal,
 * gestionará cuando desea avanzar o retroceder entre steps o bien cerrar el Wizard Modal.
 */
class WizardModalService {
    /** @ignore */
    constructor(_wizardService) {
        this._wizardService = _wizardService;
        this._steps = null;
        this._currentStep = null;
        this._firstStep = null;
        this._lastStep = null;
    }
    /**
     * Método que permite avanzar al siguiente step del listado de steps definido en el Wizard Modal
     */
    next() {
        const orderedSteps = this._steps
            .filter((step) => this.isStepShowed(step) && this.isStepEnabled(step))
            .sort((first, last) => first.order - last.order);
        for (let i = 0; i < orderedSteps.length; i++) {
            if (orderedSteps[i].id === this._currentStep.id && orderedSteps.length > i + 1) {
                this._currentStep = orderedSteps[i + 1];
                const index = this._steps.findIndex(step => step.id === this._currentStep.id);
                this._steps[index].checked = true;
                break;
            }
        }
    }
    /**
     * Método que permite retroceder al anterior step del listado de steps definido en el Wizard Modal
     */
    prev() {
        const orderedSteps = this._steps
            .filter((step) => this.isStepShowed(step) && this.isStepEnabled(step))
            .sort((first, last) => first.order - last.order);
        for (let i = orderedSteps.length - 1; i > 0; i--) {
            if (orderedSteps[i].id === this._currentStep.id && i > 0) {
                const index = this._steps.findIndex(step => step.id === this._currentStep.id);
                this._steps[index].checked = false;
                this._currentStep = orderedSteps[i - 1];
                break;
            }
        }
    }
    /**
     * Método que permite cerrar de forma permanente el Wizard Modal
     */
    close() {
        this._wizardService.activeWizard.close();
    }
    isStepShowed(step) {
        return step.show === undefined || step.show() !== false;
    }
    isStepEnabled(step) {
        return step.enabled === undefined || step.enabled() !== false;
    }
    /** @ignore */
    setSteps(steps) {
        this.steps = steps;
        this._firstStep = this.getFirstStep(this._steps);
        this._lastStep = this.getLastStep(this._steps);
        this._currentStep = this._firstStep;
        this._steps[0].checked = true;
    }
    getFirstStep(steps) {
        let orderedSteps = steps.sort((first, last) => first.order - last.order);
        return orderedSteps.length > 0 ? orderedSteps[0] : null;
    }
    getLastStep(steps) {
        let orderedSteps = steps.sort((first, last) => first.order - last.order);
        return orderedSteps.length > 0 ? orderedSteps[orderedSteps.length - 1] : null;
    }
    /** @ignore */
    get currentStep() {
        return this._currentStep;
    }
    /** @ignore */
    get firstStep() {
        return this._firstStep;
    }
    /** @ignore */
    get lastStep() {
        return this._lastStep;
    }
    /** @ignore */
    get steps() {
        return this._steps;
    }
    /** @ignore */
    set steps(steps) {
        this._steps = steps;
    }
}
WizardModalService.ɵfac = function WizardModalService_Factory(t) { return new (t || WizardModalService)(ɵngcc0.ɵɵinject(WizardService)); };
WizardModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WizardModalService, factory: WizardModalService.ɵfac });
/** @nocollapse */
WizardModalService.ctorParameters = () => [
    { type: WizardService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WizardModalService, [{
        type: Injectable
    }], function () { return [{ type: WizardService }]; }, null); })();

/**
 * Este componente sirve para la declaración de una modal de tipo Wizard. Este componente recibe como Inputs los steps que mostrará
 * de tipo [INgwkWizardStep]{@link INgwkWizardStep}, unos resources de tipo [INgwkWizardResources]{@link INgwkWizardResources} y
 * un título para el índice del Wizard. De forma opcional recibirá como Inputs también unos booleanos que determinarán si
 * los botones de Next, Previous, Discard y Close están deshabilitados o no. Finalmente, para que el Wizard Modal pueda funcionar
 * correctamente, el usuario tendrá que implementar los métodos que ejecutaran los botones a través de los Outputs 'next',
 * 'prev', 'discard' y 'close'. Estos métodos se podrán implementar como el usuario prefiera, pero mantener una lógica tendrán
 * que utilizar el [Wizard Modal Service]{@link WizardModalService} para llamar a los métodos 'next()', 'prev()' y 'close()'
 * dentro de los métodos implementados para gestionar el paso de los steps y el cierre final del Wizard Modal.
 *
 * @example
 *      <ngwk-wizard-modal
 *          [steps]="steps"
 *          [wizardTitle]="title"
 *          [resources]="resources"
 *          [nextDisabled]="nextDisabled"
 *          [prevDisabled]="prevDisabled"
 *          [discardDisabled]="discardDisabled"
 *          [closeDisabled]="closeDisabled"
 *          [closeIconDisabled]="closeIconDisabled"
 *          [nextVisible]="nextVisible"
 *          [prevVisible]="prevVisible"
 *          [discardVisible]="discardVisible"
 *          [closeVisible]="closeVisible"
 *          [closeIconVisible]="closeIconVisible"
 *          (next)="onNext($event)"
 *          (prev)="onPrev($event)"
 *          (discard)="onDiscard($event)"
 *          (close)="onClose($event)"
 *          (closeIcon)="onCloseIcon($event)">
 *      </ngwk-wizard-modal>
 */
class WizardModalComponent {
    /** @ignore */
    constructor(_wizardModalService, _cdRef, _elRef) {
        this._wizardModalService = _wizardModalService;
        this._cdRef = _cdRef;
        this._elRef = _elRef;
        /** Permite definir el título principal del Wizard Modal, que aparece justo encima del Index. */
        this.wizardTitle = null;
        /** Permite definir los recursos del Wizard Modal. Son principalmente las label de los botones. */
        this.resources = null;
        /** Permite habilitar o deshabilitar el botón de 'nextButton' del Wizard Modal. */
        this.nextDisabled = false;
        /** Permite habilitar o deshabilitar el botón de 'prevButton' del Wizard Modal. */
        this.prevDisabled = false;
        /** Permite habilitar o deshabilitar el botón de 'discardButton' del Wizard Modal */
        this.discardDisabled = false;
        /** Permite habilitar o deshabilitar el botón de 'closeButton' del Wizard Modal. */
        this.closeDisabled = false;
        /** Permite habilitar o deshabilitar el icono de cerrar del Wizard Modal */
        this.closeIconDisabled = false;
        /** Permite mostrar u ocultar el botón de 'nextButton' del Wizard Modal. */
        this.nextVisible = true;
        /** Permite mostrar u ocultar el botón de 'prevButton' del Wizard Modal. */
        this.prevVisible = true;
        /** Permite mostrar u ocultar el botón de 'discardButton' del Wizard Modal */
        this.discardVisible = true;
        /** Permite mostrar u ocultar el botón de 'closeButton' del Wizard Modal. */
        this.closeVisible = true;
        /** Permite mostrar u ocultar el icono de cerrar del Wizard Modal */
        this.closeIconVisible = true;
        /** Emite un evento cuando se hace click en el botón de 'nextButton' */
        this.next = new EventEmitter();
        /** Emite un evento cuando se hace click en el botón de 'prevButton' */
        this.prev = new EventEmitter();
        /** Emite un evento cuando se hace click en el botón de 'discardButton' */
        this.discard = new EventEmitter();
        /** Emite un evento cuando se hace click en el botón de 'closeButton' */
        this.close = new EventEmitter();
        /** Emite un evento cuando se hace click en el icono de cerrar */
        this.closeIcon = new EventEmitter();
    }
    /** @ignore */
    ngAfterViewInit() {
        let autoFocus = this._elRef.nativeElement.querySelector('[ngwkAutofocus]');
        if (autoFocus) {
            let autoFocusElement = autoFocus.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (autoFocusElement) {
                autoFocusElement.focus();
                this._cdRef.detectChanges();
            }
        }
    }
    //#region Index
    /** @ignore */
    setDisabledColor(step) {
        return step.enabled !== undefined && step.enabled() === false;
    }
    /** @ignore */
    setCheckedOvalColor(step) {
        return step.checked;
    }
    /** @ignore */
    setIndexSelected(step) {
        return step.id === this.currentStep.id;
    }
    /** @ignore */
    setIndexDisabled(step) {
        return step.id !== this.currentStep.id && step.enabled !== undefined && step.enabled() === false;
    }
    /** @ignore */
    isStepShowed(step) {
        return step.show === undefined || step.show() !== false;
    }
    /** @ignore */
    isCloseIconDisabled() {
        return this.closeIconDisabled ? true : null;
    }
    //#endregion
    //#region Content
    /** @ignore */
    getContentTitle() {
        return this.currentStep.contentTitle ? this.currentStep.contentTitle : this.currentStep.indexTitle;
    }
    //#endregion
    //#region Footer
    /** @ignore */
    isFirstStep() {
        return this.currentStep === this.firstStep;
    }
    /** @ignore */
    isLastStep() {
        return this.currentStep === this.lastStep;
    }
    /** @ignore */
    onNext() {
        this.next.emit(this.currentStep);
    }
    /** @ignore */
    onPrev() {
        this.prev.emit(this.currentStep);
    }
    /** @ignore */
    onDiscard() {
        this.discard.emit(this.currentStep);
    }
    /** @ignore */
    onClose() {
        this.close.emit(this.currentStep);
    }
    /** @ignore */
    onCloseIcon() {
        this.closeIcon.emit(this.currentStep);
    }
    //#endregion
    //#region Step
    /** @ignore */
    get currentStep() {
        return this._wizardModalService.currentStep;
    }
    /** @ignore */
    get firstStep() {
        return this._wizardModalService.firstStep;
    }
    /** @ignore */
    get lastStep() {
        return this._wizardModalService.lastStep;
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite obtener los steps que se mostrarán en el Wizard Modal
     */
    get steps() {
        return this._wizardModalService.steps;
    }
    /**
     * Permite definir los steps que se mostrarán en el Wizard Modal
     *
     * @param value Los steps que se mostrarán en el Wizard Modal
     */
    set steps(value) {
        this._wizardModalService.setSteps(value);
    }
}
WizardModalComponent.ɵfac = function WizardModalComponent_Factory(t) { return new (t || WizardModalComponent)(ɵngcc0.ɵɵdirectiveInject(WizardModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
WizardModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WizardModalComponent, selectors: [["ngwk-wizard-modal"]], inputs: { wizardTitle: "wizardTitle", resources: "resources", nextDisabled: "nextDisabled", prevDisabled: "prevDisabled", discardDisabled: "discardDisabled", closeDisabled: "closeDisabled", closeIconDisabled: "closeIconDisabled", nextVisible: "nextVisible", prevVisible: "prevVisible", discardVisible: "discardVisible", closeVisible: "closeVisible", closeIconVisible: "closeIconVisible", steps: "steps" }, outputs: { next: "next", prev: "prev", discard: "discard", close: "close", closeIcon: "closeIcon" }, decls: 28, vars: 10, consts: [[1, "horizontalLayout", "wizardModalContent", 2, "height", "100%"], [1, "colAuto", "verticalLayout", "wizardIndexZone"], [1, "rowAvailable", "verticalLayout", "wizardIndexPanel"], [1, "wizardIndexTitle"], [1, "wizardIndexList"], [4, "ngFor", "ngForOf"], [1, "colAvailable", "verticalLayout", "wizardContentZone"], [1, "rowAuto", "horizontalLayout", "wizardHeaderZone"], [1, "colAvailable", "verticalLayout", "wizardHeader"], [1, "rowAuto", "alignVerticalMiddle", "wizardHeaderTitle"], [1, "rowAuto", "alignVerticalMiddle", "wizardHeaderDescription"], ["class", "colAuto wizardCloseIcon", 4, "ngIf"], [1, "rowAvailable", "verticalLayout"], [1, "rowAuto"], [1, "horizontalLayout", "wizardFooterZone"], [1, "colAuto"], ["class", "buttonPrimaryTransparent", 3, "disabled", "click", 4, "ngIf"], [1, "colAvailable"], ["class", "buttonPrimary", 3, "disabled", "click", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [2, "height", "100%"], [1, "ovalListItem", 3, "ngClass"], [1, "colAuto", "wizardCloseIcon"], ["key", "closeIcon", 1, "closeWindowIcon", 3, "click"], ["class", "rowAvailable verticalLayout wizardContentPadding", 4, "ngIf"], [1, "rowAvailable", "verticalLayout", "wizardContentPadding"], [4, "ngTemplateOutlet"], [1, "buttonPrimaryTransparent", 3, "disabled", "click"], [1, "buttonPrimary", 3, "disabled", "click"]], template: function WizardModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "ul", 4);
        ɵngcc0.ɵɵtemplate(6, WizardModalComponent_span_6_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "span");
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵelementStart(14, "span");
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, WizardModalComponent_div_16_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 12);
        ɵngcc0.ɵɵtemplate(18, WizardModalComponent_ng_container_18_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 13);
        ɵngcc0.ɵɵelementStart(20, "div", 14);
        ɵngcc0.ɵɵelementStart(21, "div", 15);
        ɵngcc0.ɵɵtemplate(22, WizardModalComponent_button_22_Template, 2, 2, "button", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(23, "div", 17);
        ɵngcc0.ɵɵelementStart(24, "div", 15);
        ɵngcc0.ɵɵtemplate(25, WizardModalComponent_button_25_Template, 2, 2, "button", 16);
        ɵngcc0.ɵɵtemplate(26, WizardModalComponent_button_26_Template, 2, 2, "button", 18);
        ɵngcc0.ɵɵtemplate(27, WizardModalComponent_button_27_Template, 2, 2, "button", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.wizardTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.getContentTitle());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.currentStep.contentDescription);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeIconVisible);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.discardVisible);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isFirstStep() && ctx.prevVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLastStep() && ctx.nextVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLastStep() && ctx.closeVisible);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc4.IconComponent, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]     .wizardModalContent{min-height:500px;max-height:500px;min-width:800px}[_nghost-%COMP%]     .wizardModalContent .wizardIndexZone{width:13rem;border-radius:4px}[_nghost-%COMP%]     .wizardModalContent .wizardIndexPanel{background-color:#f8f8f8;color:#444;padding:.8rem 1.2rem;border-radius:4px 0 0 4px}[_nghost-%COMP%]     .wizardModalContent .wizardContentZone{background-color:#fff;border-radius:0 4px 4px 0;min-width:350px;position:relative}[_nghost-%COMP%]     .wizardModalContent .wizardContentZone .wizardHeaderZone{min-height:40px}[_nghost-%COMP%]     .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader{padding:20px 15px 15px 20px}[_nghost-%COMP%]     .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader .wizardHeaderTitle{margin-bottom:5px;color:#da6c00}[_nghost-%COMP%]     .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader .wizardHeaderDescription{margin-top:5px;font-size:13px;color:#666}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon{padding:15px}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon .closeWindowIcon{z-index:1}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon .closeWindowIcon .baseIcon{height:18px;width:18px;color:#bdbdbd}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon .closeWindowIcon:hover{cursor:pointer}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon .closeWindowIcon:hover .baseIcon{color:#848484}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon .closeWindowIcon:active .baseIcon{color:#545454}[_nghost-%COMP%]     .wizardModalContent .wizardCloseIcon[disabled]{opacity:.5;cursor:default!important;pointer-events:none}[_nghost-%COMP%]     .wizardModalContent .wizardContentPadding{padding:20px}[_nghost-%COMP%]     .wizardModalContent .wizardContentPadding .wizardLargeInput{width:80%}[_nghost-%COMP%]     .wizardModalContent .wizardContentPadding .wizardMediumInput{padding-right:10px;width:calc(40% - 5px)}[_nghost-%COMP%]     .wizardModalContent .wizardIndexTitle{text-transform:uppercase;font-size:16px;text-align:center;margin:24px 0 40px;color:#0081c6}[_nghost-%COMP%]     .wizardModalContent .wizardIndexList{list-style:none;padding:0;margin:0;font-size:11px;color:#444;text-transform:uppercase}[_nghost-%COMP%]     .wizardModalContent .wizardIndexList li{display:flex;align-items:center;margin-bottom:1rem}[_nghost-%COMP%]     .wizardModalContent .ovalListItem{box-sizing:border-box;min-height:9px;min-width:9px;border:1px solid #CCC;border-radius:25px;margin-right:.4rem;margin-top:2px}[_nghost-%COMP%]     .wizardModalContent .ovalListItemDisabled{opacity:.6}[_nghost-%COMP%]     .wizardModalContent .ovalListItemChecked{border:1px solid #0081c6;background-color:#0081c6}[_nghost-%COMP%]     .wizardModalContent .wizardIndexSelected{color:#0081c6;align-items:flex-start!important}[_nghost-%COMP%]     .wizardModalContent .wizardIndexDisabled{opacity:.6}[_nghost-%COMP%]     .wizardModalContent .wizardFooterZone{border-top:1px solid #ddd;padding:.4rem}[_nghost-%COMP%]     .wizardModalContent .wizardContentSubtitleText{color:#666;font-size:13px;margin:0 .63rem .63rem;white-space:pre-line}[_nghost-%COMP%]     .wizardModalContent .wizardModalWrapper .modal-content{height:63vh;width:63vw;max-width:85vw;min-width:50rem;max-height:85vh;min-height:39rem}[_nghost-%COMP%]     .wizardModalContent .wizardSummaryTextMargin{margin-bottom:15px}[_nghost-%COMP%]     .wizardModalContent .wizardSummaryPrimary{margin-bottom:20px;font-size:12px}[_nghost-%COMP%]     .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryText{margin-left:10px;color:#373737}[_nghost-%COMP%]     .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryIconFirst i{color:#287233}[_nghost-%COMP%]     .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryIconSecond i{color:#80bde1}[_nghost-%COMP%]     .wizardModalContent .wizardSummarySecondary{font-size:12px}[_nghost-%COMP%]     .wizardModalContent .wizardSummarySecondary .wizardSummaryFirstCol{color:#747474;width:100px}[_nghost-%COMP%]     .wizardModalContent .wizardSummarySecondary .wizardSummarySecondCol{width:400px;color:#373737}"] });
/** @nocollapse */
WizardModalComponent.ctorParameters = () => [
    { type: WizardModalService },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
WizardModalComponent.propDecorators = {
    wizardTitle: [{ type: Input }],
    resources: [{ type: Input }],
    nextDisabled: [{ type: Input }],
    prevDisabled: [{ type: Input }],
    discardDisabled: [{ type: Input }],
    closeDisabled: [{ type: Input }],
    closeIconDisabled: [{ type: Input }],
    nextVisible: [{ type: Input }],
    prevVisible: [{ type: Input }],
    discardVisible: [{ type: Input }],
    closeVisible: [{ type: Input }],
    closeIconVisible: [{ type: Input }],
    next: [{ type: Output }],
    prev: [{ type: Output }],
    discard: [{ type: Output }],
    close: [{ type: Output }],
    closeIcon: [{ type: Output }],
    steps: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WizardModalComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-wizard-modal',
                template: "<div class=\"horizontalLayout wizardModalContent\" style=\"height:100%;\">\r\n    <div class=\"colAuto verticalLayout wizardIndexZone\">\r\n        <div class=\"rowAvailable verticalLayout wizardIndexPanel\">\r\n            <span class=\"wizardIndexTitle\">{{wizardTitle}}</span>\r\n            <ul class=\"wizardIndexList\">\r\n                <span *ngFor=\"let step of steps\">\r\n                    <li *ngIf=\"isStepShowed(step)\" [ngClass]=\"{ 'wizardIndexSelected' : setIndexSelected(step), 'wizardIndexDisabled' : setIndexDisabled(step) }\">\r\n                        <div style=\"height: 100%\">\r\n                            <div class=\"ovalListItem\" [ngClass]=\"{ 'ovalListItemDisabled' : setDisabledColor(step), 'ovalListItemChecked' : setCheckedOvalColor(step)  }\"></div>\r\n                        </div>\r\n                        <span [ngClass]=\"{ 'wizardIndexDisabled' : setDisabledColor(step) }\">\r\n                            {{step.indexTitle}}\r\n                        </span>\r\n                    </li>\r\n                </span>\r\n            </ul>\r\n        </div>                \r\n    </div>\r\n    <div class=\"colAvailable verticalLayout wizardContentZone\">\r\n        <div class=\"rowAuto horizontalLayout wizardHeaderZone\">\r\n            <div class=\"colAvailable verticalLayout wizardHeader\">\r\n                <div class=\"rowAuto alignVerticalMiddle wizardHeaderTitle\">\r\n                    <span>{{getContentTitle()}}</span>\r\n                </div>\r\n                <div class=\"rowAuto alignVerticalMiddle wizardHeaderDescription\">\r\n                    <span>{{currentStep.contentDescription}}</span>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"closeIconVisible\" class=\"colAuto wizardCloseIcon\" [attr.disabled]=\"isCloseIconDisabled()\">\r\n                <ucc-icon class=\"closeWindowIcon\" key=\"closeIcon\" (click)=\"onCloseIcon()\"></ucc-icon>\r\n            </div>\r\n        </div>\r\n        <div class=\"rowAvailable verticalLayout\">\r\n            <ng-container *ngFor=\"let step of steps\">\r\n                <div class=\"rowAvailable verticalLayout wizardContentPadding\" *ngIf=\"currentStep.id === step.id\">\r\n                    <ng-template *ngTemplateOutlet=\"step.template\"></ng-template>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n        <div class=\"rowAuto\">\r\n            <div class=\"horizontalLayout wizardFooterZone\">\r\n                <div class=\"colAuto\">\r\n                    <button *ngIf=\"discardVisible\" class=\"buttonPrimaryTransparent\" [disabled]=\"discardDisabled\" (click)=\"onDiscard()\">{{resources.discardButton}}</button>\r\n                </div>\r\n                <div class=\"colAvailable\"></div>\r\n                <div class=\"colAuto\">\r\n                    <button *ngIf=\"!isFirstStep() && prevVisible\" [disabled]=\"prevDisabled\" class=\"buttonPrimaryTransparent\" (click)=\"onPrev()\">{{resources.prevButton}}</button>\r\n                    <button *ngIf=\"!isLastStep() && nextVisible\" [disabled]=\"nextDisabled\" class=\"buttonPrimary\" (click)=\"onNext()\">{{resources.nextButton}}</button>\r\n                    <button *ngIf=\"isLastStep() && closeVisible\" [disabled]=\"closeDisabled\" class=\"buttonPrimary\" (click)=\"onClose()\">{{resources.closeButton}}</button>\r\n                </div>\r\n            </div>            \r\n        </div>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .wizardModalContent{min-height:500px;max-height:500px;min-width:800px}:host ::ng-deep .wizardModalContent .wizardIndexZone{width:13rem;border-radius:4px}:host ::ng-deep .wizardModalContent .wizardIndexPanel{background-color:#f8f8f8;color:#444;padding:.8rem 1.2rem;border-radius:4px 0 0 4px}:host ::ng-deep .wizardModalContent .wizardContentZone{background-color:#fff;border-radius:0 4px 4px 0;min-width:350px;position:relative}:host ::ng-deep .wizardModalContent .wizardContentZone .wizardHeaderZone{min-height:40px}:host ::ng-deep .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader{padding:20px 15px 15px 20px}:host ::ng-deep .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader .wizardHeaderTitle{margin-bottom:5px;color:#da6c00}:host ::ng-deep .wizardModalContent .wizardContentZone .wizardHeaderZone .wizardHeader .wizardHeaderDescription{margin-top:5px;font-size:13px;color:#666}:host ::ng-deep .wizardModalContent .wizardCloseIcon{padding:15px}:host ::ng-deep .wizardModalContent .wizardCloseIcon .closeWindowIcon{z-index:1}:host ::ng-deep .wizardModalContent .wizardCloseIcon .closeWindowIcon .baseIcon{height:18px;width:18px;color:#bdbdbd}:host ::ng-deep .wizardModalContent .wizardCloseIcon .closeWindowIcon:hover{cursor:pointer}:host ::ng-deep .wizardModalContent .wizardCloseIcon .closeWindowIcon:hover .baseIcon{color:#848484}:host ::ng-deep .wizardModalContent .wizardCloseIcon .closeWindowIcon:active .baseIcon{color:#545454}:host ::ng-deep .wizardModalContent .wizardCloseIcon[disabled]{opacity:.5;cursor:default!important;pointer-events:none}:host ::ng-deep .wizardModalContent .wizardContentPadding{padding:20px}:host ::ng-deep .wizardModalContent .wizardContentPadding .wizardLargeInput{width:80%}:host ::ng-deep .wizardModalContent .wizardContentPadding .wizardMediumInput{padding-right:10px;width:calc(40% - 5px)}:host ::ng-deep .wizardModalContent .wizardIndexTitle{text-transform:uppercase;font-size:16px;text-align:center;margin:24px 0 40px;color:#0081c6}:host ::ng-deep .wizardModalContent .wizardIndexList{list-style:none;padding:0;margin:0;font-size:11px;color:#444;text-transform:uppercase}:host ::ng-deep .wizardModalContent .wizardIndexList li{display:flex;align-items:center;margin-bottom:1rem}:host ::ng-deep .wizardModalContent .ovalListItem{box-sizing:border-box;min-height:9px;min-width:9px;border:1px solid #CCC;border-radius:25px;margin-right:.4rem;margin-top:2px}:host ::ng-deep .wizardModalContent .ovalListItemDisabled{opacity:.6}:host ::ng-deep .wizardModalContent .ovalListItemChecked{border:1px solid #0081c6;background-color:#0081c6}:host ::ng-deep .wizardModalContent .wizardIndexSelected{color:#0081c6;align-items:flex-start!important}:host ::ng-deep .wizardModalContent .wizardIndexDisabled{opacity:.6}:host ::ng-deep .wizardModalContent .wizardFooterZone{border-top:1px solid #ddd;padding:.4rem}:host ::ng-deep .wizardModalContent .wizardContentSubtitleText{color:#666;font-size:13px;margin:0 .63rem .63rem;white-space:pre-line}:host ::ng-deep .wizardModalContent .wizardModalWrapper .modal-content{height:63vh;width:63vw;max-width:85vw;min-width:50rem;max-height:85vh;min-height:39rem}:host ::ng-deep .wizardModalContent .wizardSummaryTextMargin{margin-bottom:15px}:host ::ng-deep .wizardModalContent .wizardSummaryPrimary{margin-bottom:20px;font-size:12px}:host ::ng-deep .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryText{margin-left:10px;color:#373737}:host ::ng-deep .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryIconFirst i{color:#287233}:host ::ng-deep .wizardModalContent .wizardSummaryPrimary .wizardSummaryPrimaryIconSecond i{color:#80bde1}:host ::ng-deep .wizardModalContent .wizardSummarySecondary{font-size:12px}:host ::ng-deep .wizardModalContent .wizardSummarySecondary .wizardSummaryFirstCol{color:#747474;width:100px}:host ::ng-deep .wizardModalContent .wizardSummarySecondary .wizardSummarySecondCol{width:400px;color:#373737}\n"]
            }]
    }], function () { return [{ type: WizardModalService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { wizardTitle: [{
            type: Input
        }], resources: [{
            type: Input
        }], nextDisabled: [{
            type: Input
        }], prevDisabled: [{
            type: Input
        }], discardDisabled: [{
            type: Input
        }], closeDisabled: [{
            type: Input
        }], closeIconDisabled: [{
            type: Input
        }], nextVisible: [{
            type: Input
        }], prevVisible: [{
            type: Input
        }], discardVisible: [{
            type: Input
        }], closeVisible: [{
            type: Input
        }], closeIconVisible: [{
            type: Input
        }], next: [{
            type: Output
        }], prev: [{
            type: Output
        }], discard: [{
            type: Output
        }], close: [{
            type: Output
        }], closeIcon: [{
            type: Output
        }], steps: [{
            type: Input
        }] }); })();

class WizardModule {
}
WizardModule.ɵfac = function WizardModule_Factory(t) { return new (t || WizardModule)(); };
WizardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: WizardModule });
WizardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        WizardService,
        WizardModalService
    ], imports: [[
            CommonModule,
            FormsModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WizardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule
                ],
                declarations: [
                    WizardModalComponent
                ],
                exports: [
                    WizardModalComponent
                ],
                providers: [
                    WizardService,
                    WizardModalService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WizardModule, { declarations: function () { return [WizardModalComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule]; }, exports: function () { return [WizardModalComponent]; } }); })();

/**
 * Este componente sirve para declarar un contenido extra que sirve de apoyo a la información que aporte la página.
 * Contiene dos estados diferentes:
 *
 *
 * -Expanded: Se muestra el contenido de apoyo a la página actual. Se puede esconder pulsando el icono de contraer el contenido y pasará a
 * estado 'No Expanded'
 *
 * -No Expanded: Se oculta el contenido de apoyo, haciendo que se muestre únicamente un icono para volver al estado de 'Expanded', a parte
 * de un contenido personalizable extra que se puede situar justo debajo sin ocupar mucho espacio
 *
 * @example
 *  <ngwk-anchor>
 *      <anchor-not-expanded>
 *          Content Not Expanded
 *      </anchor-not-expanded>
 *      <anchor-expanded>
 *          Content Expanded
 *      </anchor-expanded>
 *  </ngwk-anchor>
 */
class AnchorComponent {
    /**@ignore */
    constructor() {
        this._expanded = true;
    }
    /**
     * Permite obtener el valor actual del parámetro 'expanded' del componente Anchor
     *
     * @return
     */
    get expanded() {
        return this._expanded;
    }
    /**
     * Esta función sirve para cambiar el valor del parámetro 'expanded' del componente Anchor
     *
     * @param value Valor nuevo del parámetro 'expanded'
     * @return
     */
    set expanded(value) {
        this._expanded = value;
    }
    /** @ignore */
    onChangeExpanded() {
        this.expanded = !this.expanded;
    }
}
AnchorComponent.ɵfac = function AnchorComponent_Factory(t) { return new (t || AnchorComponent)(); };
AnchorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AnchorComponent, selectors: [["ngwk-anchor"]], inputs: { expanded: "expanded" }, ngContentSelectors: _c27, decls: 5, vars: 3, consts: [[1, "anchorWrapper", "rowAvailable", "verticalLayout", 3, "ngClass"], [1, "anchorArrowButton"], ["key", "angle-left", 3, "click"], ["class", "rowAvailable verticalLayout", 4, "ngIf"], [1, "rowAvailable", "verticalLayout"], [1, "horizontalLayout", "rowAvailable"]], template: function AnchorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c26);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ucc-icon", 2);
        ɵngcc0.ɵɵlistener("click", function AnchorComponent_Template_ucc_icon_click_2_listener() { return ctx.onChangeExpanded(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, AnchorComponent_div_3_Template, 3, 0, "div", 3);
        ɵngcc0.ɵɵtemplate(4, AnchorComponent_div_4_Template, 3, 0, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.expanded ? "widthExpanded" : "widthCollapsed");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.expanded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.expanded);
    } }, directives: [ɵngcc1.NgClass, ɵngcc4.IconComponent, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded{margin-top:30px}[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded .anchorTitlePrimary{white-space:nowrap;transform:rotate(180deg);writing-mode:vertical-lr;text-orientation:right;user-select:none;margin-top:3px;line-height:3px}[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded .anchorID{white-space:nowrap;transform:rotate(180deg);writing-mode:vertical-lr;text-orientation:right;user-select:none;margin-top:3px;line-height:3px;color:#a9a9a9;font-weight:normal;font-size:13px}[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded .anchorIconWrapper{border:1px solid #ccc;border-radius:100%;margin-bottom:15px;margin-top:10px;height:30px;width:30px;color:#e5e5e5;position:relative}[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded .anchorIconWrapper .anchorMiniIcon{position:absolute;bottom:-2px;right:-3px;height:13px;width:13px;background-color:#94c265;border:1px solid white;border-radius:100%}[_nghost-%COMP%]     anchor-collapsed .widthNotExpanded .anchorIconWrapper img{width:30px;height:30px;border-radius:100%}[_nghost-%COMP%]     anchor-collapsed{animation:fadeIn 1.1s ease}[_nghost-%COMP%]     .anchorWrapper{transition:width .5s ease;border-right:1px solid #ccc;position:relative}[_nghost-%COMP%]     .widthExpanded{width:300px}[_nghost-%COMP%]     .widthCollapsed{width:45px}[_nghost-%COMP%]     .widthCollapsed .anchorArrowButton{transform:rotate(180deg)}[_nghost-%COMP%]     .anchorArrowButton{position:absolute;right:10px;top:10px;z-index:1;transform:rotate(0);transition:transform .3s ease;color:#999;cursor:pointer}[_nghost-%COMP%]     .anchorArrowButton:hover{color:#474747}[_nghost-%COMP%]     .anchorCollapsed{display:inline-grid;justify-content:right;margin:10px}[_nghost-%COMP%]     anchor-expanded{flex:1 1;position:relative;overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:column;width:100%}[_nghost-%COMP%]     anchor-expanded .anchorContentMargin{display:flex;padding-right:40px;width:100%}[_nghost-%COMP%]     anchor-expanded .anchorSeparator{height:1px;background-color:#eee;margin-bottom:10px}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection{display:flex;position:relative}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorStateBar{position:absolute;left:0px;height:100%;width:40px;background-color:#94c265}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorIconWrapper{border:1px solid #ccc;border-radius:100%;height:60px;width:60px;margin:30px 10px;background-color:#fff;position:relative;z-index:1}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorIconWrapper i{font-size:40px;color:#e5e5e5}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorIconWrapper .anchorMiniIcon{position:absolute;bottom:-2px;right:-2px;height:25px;width:25px;background-color:#0081c6;border:2px solid white;border-radius:100%}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorIconWrapper .anchorMiniIcon i{font-size:14px;color:#fff}[_nghost-%COMP%]     anchor-expanded .anchorHeaderSection .anchorInfoUser{word-wrap:break-word}[_nghost-%COMP%]     anchor-expanded .anchorHighlightedSection{margin:5px 10px;width:280px}[_nghost-%COMP%]     anchor-expanded{animation:fadeIn 1.4s ease}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}[_nghost-%COMP%]     .anchorCompanyInfo{display:block;justify-content:center;margin:50px 0 30px}[_nghost-%COMP%]     .anchorCompanyInfo .anchorPhotoCompany{height:127px;position:relative;margin:0 35px;border:1px solid #ccc;background-color:#fff;display:flex;align-items:center;justify-content:center}[_nghost-%COMP%]     .anchorCompanyInfo .anchorPhotoCompany .photoCompany{display:flex;align-items:center;justify-content:center;width:100%;height:100%}[_nghost-%COMP%]     .anchorCompanyInfo .anchorPhotoCompany .photoCompany img{object-fit:contain;background-repeat:no-repeat;max-width:100%;max-height:100%}[_nghost-%COMP%]     .anchorCompanyInfo .anchorPhotoCompany .anchorCompanyUploadPhoto{position:absolute;bottom:-20px;right:10px}[_nghost-%COMP%]     .anchorCompanyInfo .anchorPhotoCompany .anchorCompanyUploadPhoto ucc-icon{height:40px;width:40px;border-radius:100%;display:flex;align-items:center;justify-content:center;color:#fff;background-color:#0081c6}[_nghost-%COMP%]     .anchorCompanyInfo .anchorCompanyInfoText{margin-top:30px;text-align:center;padding:0 25px}[_nghost-%COMP%]     .anchorTextBasic{font-size:13px}[_nghost-%COMP%]     .anchorTitlePrimary{font-size:13px;font-family:\"FiraSans Semibold\";margin-top:3px}[_nghost-%COMP%]     .anchorSubtextUser{font-size:13px;color:#373737;margin-top:5px}[_nghost-%COMP%]     .anchorDataUser{font-size:13px;color:#666;margin-top:5px}[_nghost-%COMP%]     .anchorSubtextPhone{font-size:13px;color:#999}[_nghost-%COMP%]     .anchorStatusOk{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px}[_nghost-%COMP%]     .anchorStatusWarning{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px;background-color:#fd9644}[_nghost-%COMP%]     .anchorStatusError{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px;background-color:red}[_nghost-%COMP%]     .anchorContent{color:#373737;font-size:13px;text-decoration:none}[_nghost-%COMP%]     .fadeGradient{position:fixed;z-index:2;height:200px;background-image:linear-gradient(to top,rgba(255,255,255,0) 40%,#ffffff 85%)}"] });
/** @nocollapse */
AnchorComponent.ctorParameters = () => [];
AnchorComponent.propDecorators = {
    expanded: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnchorComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-anchor',
                template: "<div class=\"anchorWrapper rowAvailable verticalLayout\" [ngClass]=\"expanded ? 'widthExpanded' : 'widthCollapsed'\">\r\n    <div class='anchorArrowButton'>\r\n        <ucc-icon key='angle-left' (click)='onChangeExpanded()'></ucc-icon>\r\n    </div>\r\n    <div *ngIf=\"expanded\" class=\"rowAvailable verticalLayout\">\r\n\r\n        <div class='horizontalLayout rowAvailable'>\r\n            <ng-content select='anchor-expanded'></ng-content>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"!expanded\" class=\"rowAvailable verticalLayout\">\r\n        <!--<div class='anchorCollapsed'>\r\n            <ucc-icon key='angle-right' (click)='onChangeExpanded()'></ucc-icon>\r\n        </div>-->\r\n        <div class='horizontalLayout rowAvailable'>\r\n            <ng-content select='anchor-collapsed'></ng-content>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep anchor-collapsed .widthNotExpanded{margin-top:30px}:host ::ng-deep anchor-collapsed .widthNotExpanded .anchorTitlePrimary{white-space:nowrap;transform:rotate(180deg);writing-mode:vertical-lr;text-orientation:right;user-select:none;margin-top:3px;line-height:3px}:host ::ng-deep anchor-collapsed .widthNotExpanded .anchorID{white-space:nowrap;transform:rotate(180deg);writing-mode:vertical-lr;text-orientation:right;user-select:none;margin-top:3px;line-height:3px;color:#a9a9a9;font-weight:normal;font-size:13px}:host ::ng-deep anchor-collapsed .widthNotExpanded .anchorIconWrapper{border:1px solid #ccc;border-radius:100%;margin-bottom:15px;margin-top:10px;height:30px;width:30px;color:#e5e5e5;position:relative}:host ::ng-deep anchor-collapsed .widthNotExpanded .anchorIconWrapper .anchorMiniIcon{position:absolute;bottom:-2px;right:-3px;height:13px;width:13px;background-color:#94c265;border:1px solid white;border-radius:100%}:host ::ng-deep anchor-collapsed .widthNotExpanded .anchorIconWrapper img{width:30px;height:30px;border-radius:100%}:host ::ng-deep anchor-collapsed{animation:fadeIn 1.1s ease}:host ::ng-deep .anchorWrapper{transition:width .5s ease;border-right:1px solid #ccc;position:relative}:host ::ng-deep .widthExpanded{width:300px}:host ::ng-deep .widthCollapsed{width:45px}:host ::ng-deep .widthCollapsed .anchorArrowButton{transform:rotate(180deg)}:host ::ng-deep .anchorArrowButton{position:absolute;right:10px;top:10px;z-index:1;transform:rotate(0);transition:transform .3s ease;color:#999;cursor:pointer}:host ::ng-deep .anchorArrowButton:hover{color:#474747}:host ::ng-deep .anchorCollapsed{display:inline-grid;justify-content:right;margin:10px}:host ::ng-deep anchor-expanded{flex:1 1;position:relative;overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:column;width:100%}:host ::ng-deep anchor-expanded .anchorContentMargin{display:flex;padding-right:40px;width:100%}:host ::ng-deep anchor-expanded .anchorSeparator{height:1px;background-color:#eee;margin-bottom:10px}:host ::ng-deep anchor-expanded .anchorHeaderSection{display:flex;position:relative}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorStateBar{position:absolute;left:0px;height:100%;width:40px;background-color:#94c265}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorIconWrapper{border:1px solid #ccc;border-radius:100%;height:60px;width:60px;margin:30px 10px;background-color:#fff;position:relative;z-index:1}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorIconWrapper i{font-size:40px;color:#e5e5e5}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorIconWrapper .anchorMiniIcon{position:absolute;bottom:-2px;right:-2px;height:25px;width:25px;background-color:#0081c6;border:2px solid white;border-radius:100%}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorIconWrapper .anchorMiniIcon i{font-size:14px;color:#fff}:host ::ng-deep anchor-expanded .anchorHeaderSection .anchorInfoUser{word-wrap:break-word}:host ::ng-deep anchor-expanded .anchorHighlightedSection{margin:5px 10px;width:280px}:host ::ng-deep anchor-expanded{animation:fadeIn 1.4s ease}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}:host ::ng-deep .anchorCompanyInfo{display:block;justify-content:center;margin:50px 0 30px}:host ::ng-deep .anchorCompanyInfo .anchorPhotoCompany{height:127px;position:relative;margin:0 35px;border:1px solid #ccc;background-color:#fff;display:flex;align-items:center;justify-content:center}:host ::ng-deep .anchorCompanyInfo .anchorPhotoCompany .photoCompany{display:flex;align-items:center;justify-content:center;width:100%;height:100%}:host ::ng-deep .anchorCompanyInfo .anchorPhotoCompany .photoCompany img{object-fit:contain;background-repeat:no-repeat;max-width:100%;max-height:100%}:host ::ng-deep .anchorCompanyInfo .anchorPhotoCompany .anchorCompanyUploadPhoto{position:absolute;bottom:-20px;right:10px}:host ::ng-deep .anchorCompanyInfo .anchorPhotoCompany .anchorCompanyUploadPhoto ucc-icon{height:40px;width:40px;border-radius:100%;display:flex;align-items:center;justify-content:center;color:#fff;background-color:#0081c6}:host ::ng-deep .anchorCompanyInfo .anchorCompanyInfoText{margin-top:30px;text-align:center;padding:0 25px}:host ::ng-deep .anchorTextBasic{font-size:13px}:host ::ng-deep .anchorTitlePrimary{font-size:13px;font-family:\"FiraSans Semibold\";margin-top:3px}:host ::ng-deep .anchorSubtextUser{font-size:13px;color:#373737;margin-top:5px}:host ::ng-deep .anchorDataUser{font-size:13px;color:#666;margin-top:5px}:host ::ng-deep .anchorSubtextPhone{font-size:13px;color:#999}:host ::ng-deep .anchorStatusOk{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px}:host ::ng-deep .anchorStatusWarning{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px;background-color:#fd9644}:host ::ng-deep .anchorStatusError{height:7px;width:7px;background-color:#10ac84;border-radius:100%;margin-right:5px;background-color:red}:host ::ng-deep .anchorContent{color:#373737;font-size:13px;text-decoration:none}:host ::ng-deep .fadeGradient{position:fixed;z-index:2;height:200px;background-image:linear-gradient(to top,rgba(255,255,255,0) 40%,#ffffff 85%)}\n"]
            }]
    }], function () { return []; }, { expanded: [{
            type: Input
        }] }); })();

class AnchorModule {
}
AnchorModule.ɵfac = function AnchorModule_Factory(t) { return new (t || AnchorModule)(); };
AnchorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AnchorModule });
AnchorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnchorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    AnchorComponent
                ],
                exports: [
                    AnchorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AnchorModule, { declarations: function () { return [AnchorComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [AnchorComponent]; } }); })();

class LayoutsModule {
}
LayoutsModule.ɵfac = function LayoutsModule_Factory(t) { return new (t || LayoutsModule)(); };
LayoutsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LayoutsModule });
LayoutsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            ShuttlePageModule,
            ListPageModule,
            DetailPageModule,
            WelcomeModule,
            DocumentPageModule,
            ActionbarModule,
            EmptyStateModule,
            ErrorPageModule,
            ListHeaderModule,
            AnchorModule,
            LoginModule,
            WizardModule
        ], ShuttlePageModule, ListPageModule, DetailPageModule, WelcomeModule, DocumentPageModule, ActionbarModule, EmptyStateModule, ErrorPageModule, ListHeaderModule, AnchorModule, LoginModule, WizardModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ShuttlePageModule,
                    ListPageModule,
                    DetailPageModule,
                    WelcomeModule,
                    DocumentPageModule,
                    ActionbarModule,
                    EmptyStateModule,
                    ErrorPageModule,
                    ListHeaderModule,
                    AnchorModule,
                    LoginModule,
                    WizardModule
                ],
                declarations: [],
                exports: [
                    ShuttlePageModule,
                    ListPageModule,
                    DetailPageModule,
                    WelcomeModule,
                    DocumentPageModule,
                    ActionbarModule,
                    EmptyStateModule,
                    ErrorPageModule,
                    ListHeaderModule,
                    AnchorModule,
                    LoginModule,
                    WizardModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutsModule, { imports: [ShuttlePageModule, ListPageModule, DetailPageModule, WelcomeModule, DocumentPageModule, ActionbarModule, EmptyStateModule, ErrorPageModule, ListHeaderModule, AnchorModule, LoginModule, WizardModule], exports: [ShuttlePageModule, ListPageModule, DetailPageModule, WelcomeModule, DocumentPageModule, ActionbarModule, EmptyStateModule, ErrorPageModule, ListHeaderModule, AnchorModule, LoginModule, WizardModule] }); })();

// export * from './wizard-modal.module'

/**
 * Generated bundle index. Do not edit.
 */

export { ActionbarComponent, ActionbarModule, AnchorComponent, AnchorModule, DetailPageComponent, DetailPageModule, DocumentContentLoaderComponent, DocumentPageComponent, DocumentPageModule, EmptyStateComponent, EmptyStateModule, ErrorPageComponent, ErrorPageModule, LayoutsModule, ListHeaderComponent, ListHeaderModule, ListPageComponent, ListPageContentLoaderComponent, ListPageModule, LoginComponent, LoginModule, ShuttleCardItemComponent, ShuttleCardType, ShuttlePageComponent, ShuttlePageModule, StyleType, WelcomeComponent, WelcomeModule, WizardModalComponent, WizardModalService, WizardModule, WizardService };

